<template>
	<div class="main main-really-raised w-50 ml-auto mr-auto">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="card card-signup no-shadow">
						<div
							class="card-header card-header-primary negative blue-grad w-50 d-lg-flex justify-content-between">
							<h4 class="card-title" v-if="!is_deal">{{ $t('message.contracts.edit_form') }} <span
									class="ml-3 float-right font-weight-bold">{{ the_id }}</span></h4>
							<h4 class="card-title" v-if="is_deal">{{ $t('message.contracts.view_form') }} <span
									class="ml-3 float-right font-weight-bold">{{ the_id }}</span></h4>
							<button @click="closeDocument" style="position: relative;top: 6px;z-index: 3;"
								class="btn btn-outline-primary btn-sm float-right">{{
									$t('message.contracts.close_document') }}</button>
						</div>
						<div class="card-body px-3">
							<div class="col-12">
								<!-- <div class="row mb-4">
									<div class="togglebutton other form-label-group col-sm-12 col-md-12 col-lg-4 mb-0">
										<label class="control-label-sm mb-0">
										<span>{{$t('message.contracts.send_to_adb')}}</span><br><br>
										<input :disabled=is_sent_to_adb type="checkbox" v-model="is_send_to_adb">
										<span class="toggle"></span>
										<span class="choise_2">{{$t('message.yes')}}</span>
										<span class="choise_1">{{$t('message.no')}}</span>
										</label>
									</div>
									<div v-if="is_send_to_adb" class="col-6 col-md-8 col-lg-6">
										<span class='bmd-form-group mb-1 d-block form-label-group'>
											<v-select-popup placeholder="ADB" type="adb" v-model="attis_contracts.adb" :readonly=is_sent_to_adb :disabled=is_sent_to_adb />
										</span>
									</div>
									<div v-if="is_send_to_adb" class="col-6 col-md-4 col-lg-2 text-right">
										<button :disabled=(is_sent_to_adb||!Boolean(attis_contracts.adb.value))
										class="btn btn-lg btn-outline-success text-nowrap px-3"
										style="font-size: 12px; height: 54px;" @click="saveAdb">{{$t('message.save')}} ADB</button>
									</div>
								</div> -->
							</div>
							<div class="togglebutton other mt-md-3 mb-0 form-label-group col-md-6">
								<label class="control-label-sm">
									<span>{{ $t('message.contracts.is_public') }}</span><br><br>
									<input :disabled=is_field_readonly type="checkbox"
										v-model="attis_contracts.attis_contract_is_public">
									<span class="toggle"></span>
									<span class="choise_2">{{ $t('message.yes') }}</span>
									<span class="choise_1">{{ $t('message.no') }}</span>
								</label>
							</div>
							<b-tabs pills content-class="mt-3" small v-model="current_tab">
								<b-tab :title="$t('message.contracts.contract_tab')" active id="contract-tab">
									<validation :action="go_to_error" section="contract"
										:item="attis_contracts.attis_contract_id" />
									<br>
									<div class="alert mt-2 alert-success rounded d-flex"
										v-if="attis_contracts.is_signed_by_owner || attis_contracts.is_signed_by_counterparty">
										<span v-if="attis_contracts.is_signed_by_owner" style="flex-basis: 50%">
											{{ $t('message.contracts.signed_message_' +
												attis_contracts.how_is_signed_by_owner) }}
											{{ (attis_contracts.when_is_signed_by_owner) }}<br>
											<!-- {{$store.state.user.firstName}} {{$store.state.user.lastName}}<br> -->
											{{ attis_contracts.name_of_signature_owner }}
										</span>
										<span class="has-plus-infront" v-if="attis_contracts.is_signed_by_counterparty"
											style="flex-basis: 50%">
											{{ $t('message.contracts.signed_message_' +
												attis_contracts.how_is_signed_by_counterparty) }}
											{{ (attis_contracts.when_is_signed_by_counterparty) }}<br>
											{{ attis_contracts.name_of_signature_counterparty }}<br>
											<!-- {{attis_contracts.attis_contract_contragent.display_text}} -->
										</span>
									</div>
									<span
										:class="['bmd-form-group mb-2 d-block form-label-group required translatable', placeholder_status ? 'placeholderStatus' : '', status_focused ? 'focused' : '', $v.attis_contracts.attis_contract_status.$error ? 'has-danger label-floating' : '']">
										<v-select-popup :readonly=is_field_readonly :indata="statuses"
											:placeholder="$t('message.contracts.contract_status')"
											v-model="attis_contracts.attis_contract_status" />

										<!-- <v-select :readonly=is_field_readonly id="contract_status" :options="statuses" label="display_text" :class="['form-control', attis_contracts.attis_contract_status!==''?'vs--selected':'']" v-model="attis_contracts.attis_contract_status" :placeholder="$t('message.contracts.contract_status')" @focus="statusesFocused" @blur="statusesBlurred"></v-select>
										<label for="contract_status" class="form-label-group-label shorter">{{$t('message.contracts.contract_status')}}</label> -->
										<label v-if="form_error && !$v.attis_contracts.attis_contract_status.required"
											class="control-label text-danger d-block">{{ $t('message.errors.required')
											}}</label>
									</span>
									<div class="row">
										<div class="togglebutton other mt-md-3 form-label-group required col-md-6">
											<label class="control-label-sm">
												<!--<span>{{$t('message.contracts.type')}}</span><br><br>-->
												<input :disabled=is_field_readonly type="checkbox"
													v-model="attis_contracts.attis_contract_type">
												<span class="toggle"></span>
												<span class="choise_2">{{ $t('message.contracts.type_buy') }}</span>
												<span class="choise_1">{{ $t('message.contracts.type_sell') }}</span>
											</label>
										</div>
										<div class="togglebutton other mt-md-3 form-label-group required col-md-6">
											<label class="control-label-sm">
												<!--<span>{{$t('message.contracts.case')}}</span><br><br>-->
												<input :disabled=is_field_readonly type="checkbox"
													v-model="attis_contracts.attis_contract_case">
												<span class="toggle"></span>
												<span class="choise_2">{{ $t('message.contracts.case_product') }}</span>
												<span class="choise_1">{{ $t('message.contracts.case_service') }}</span>
											</label>
										</div>
									</div>
									<translatable>
										<span
											:class="['bmd-form-group mb-2 d-block form-label-group required', $v.attis_contracts.attis_contract_subject.$error ? 'has-danger label-floating' : '']">
											<input :readonly=is_field_readonly type="text" class="form-control"
												@blur="validateField('attis_contracts.attis_contract_subject')"
												v-model="attis_contracts.attis_contract_subject"
												:placeholder="$t('message.contracts.subject')" autocomplete="off"
												style="cursor: auto;" id="contract_subject">

											<label for="contract_subject" class="form-label-group-label shorter">{{
												$t('message.contracts.subject') }}</label>
											<label
												v-if="form_error && !$v.attis_contracts.attis_contract_subject.required"
												class="control-label text-danger d-block">{{
													$t('message.errors.required') }}</label>
										</span>
									</translatable>
									<translatable>
										<span :class="['bmd-form-group mb-2 d-block form-label-group required']">
											<textarea :readonly=is_field_readonly type="text" class="form-control"
												@blur="validateField('attis_contracts.attis_contract_desc')"
												v-model="attis_contracts.attis_contract_desc"
												:placeholder="$t('message.contracts.description')" autocomplete="off"
												style="cursor: auto;" id="contract_description"></textarea>
											<label for="contract_description" class="form-label-group-label shorter">{{
												$t('message.contracts.description') }}</label>
										</span>
									</translatable>
									<div class="row">
										<div class="col-md-12 mb-2">
											<v-select-popup :readonly=is_field_readonly type='currency'
												v-model="attis_contracts.attis_contract_currency"
												:placeholder="$t('message.contracts.currency')" />
											<!-- <span :class="['bmd-form-group mb-2 d-block form-label-group', placeholder_currency?'placeholderStatus':'', currency_focused?'focused':'']">
												<v-select :readonly=is_field_readonly id="contract_currency" :options="currencies" label="display_text" :class="['form-control ', attis_contracts.attis_contract_currency.value!==''?'vs--selected':'']" v-model="attis_contracts.attis_contract_currency" :placeholder="$t('message.contracts.currency')" @focus="currenciesFocused" @blur="currenciesBlurred"></v-select>
												<label for="contract_currency" class="form-label-group-label shorter">{{$t('message.contracts.currency')}}</label>

											</span> -->
										</div>
										<div class="col-md-12">
											<span :class="['bmd-form-group mb-2 d-block form-label-group']">
												<!-- <b-form-datepicker :readonly=is_field_readonly :locale="locale" v-model="attis_contracts.attis_contract_date" :placeholder="$t('message.contracts.contract_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="contract_date"></b-form-datepicker> -->
												<datepicker value-type="YYYY-MM-DD" format="DD.MM.YYYY"
													@focus="attis_contracts.attis_contract_date = ' '"
													@blur="(attis_contracts.attis_contract_date == ' ') ? attis_contracts.attis_contract_date = '' : attis_contracts.attis_contract_date = attis_contracts.attis_contract_date"
													inputClass="form-control" :disabled=is_field_readonly
													v-model="attis_contracts.attis_contract_date"
													:placeholder="$t('message.contracts.contract_date')"
													:inputAttr="{ id: 'contract_date' }" />
												<label for="contract_date" class="form-label-group-label shorter"
													:class="(attis_contracts.attis_contract_date != '' && attis_contracts.attis_contract_date != null) ? 'topped' : ''">{{
														$t('message.contracts.contract_date') }}</label>
											</span>
										</div>
									</div>
									<br>
									<h5>{{ $t('message.contracts.products') }}</h5>
									<div class="input-group mb-3" style="width: 300px;">
										<input class="form-control" type="text" v-model="looking_for_product_number"
											style="height: 32px;"
											:placeholder="$t('message.contracts.search_by_number')">
										<div class="input-group-append">
											<button @click="lookForProductByNumber"
												class="btn btn-sm btn-outline-success">{{
													$t('message.contracts.search_by_number_button') }}</button>
										</div>
									</div>

									<b-table responsive striped hover :items="attis_contract_goods"
										:tbody-tr-class="rowClassProduct" :fields="product_fields"
										:current-page="product_page" :per-page="3">
										<template v-slot:cell(attis_cg_TNVED)="data">
											<strong>{{ data.item.attis_cg_TNVED.display_text }}</strong>
										</template>
										<template v-slot:cell(attis_cg_quantity)="data">
											<strong>{{ data.value }}
												{{ check_undefined(data.item.attis_cg_measures) }}</strong>
										</template>
										<template v-slot:cell(attis_cg_price)="data">
											<strong>{{
												addThousandsSeparator(parseFloat(data.item.attis_cg_price) *
													parseFloat(data.item.attis_cg_quantity),
													',') }}
												{{ attis_contracts.attis_contract_currency.display_text }}</strong>
										</template>

										<template v-slot:cell(remove)="data" v-if="!is_field_readonly">
											<button class="btn btn-sm btn-link text-info"
												@click="editProduct((product_page - 1) * 3 + data.index)"><i
													class="fa fa-edit"></i></button>
											<button class="btn btn-sm btn-link text-danger"
												@click="removeProduct(data.index)"><i class="fa fa-times"></i></button>
										</template>
									</b-table>
									<div v-if="!is_field_readonly" class="form-group">
										<label for="excel-goods-import">{{
											$t('message.contracts.excel_import_gooods_label') }}</label>
										<input type="file" id="excel-goods-import" :disabled="files_loading"
											class="form-control" @change="importGoodsExcel($event, index)">
									</div>
									<div class="d-flex justify-content-center">
										<b-pagination v-if="attis_contract_goods.length / 3 > 1" v-model="product_page"
											:total-rows="attis_contract_goods.length" :per-page="3"></b-pagination>
									</div>
									<transition name="slide">
										<div v-if="add_product || edit_product" class="add-product-block alert-light"
											style="margin: 0 -1em !important">
											<translatable>
												<span
													:class="['bmd-form-group mb-1 d-block form-label-group', $v.product.attis_cg_good_name.$error ? 'has-danger label-floating' : '']">
													<input type="text" id="attis_cg_good_name" class="form-control "
														v-model="product.attis_cg_good_name"
														:placeholder="$t('message.contracts.product_title')"
														autocomplete="off" style="cursor: auto;">
													<label for="attis_cg_good_name"
														class="form-label-group-label shorter">{{
															$t('message.contracts.product_title') }}</label>
													<label
														v-if="product_error && !$v.product.attis_cg_good_name.required"
														class="control-label text-danger">{{
															$t('message.errors.required') }}</label>
												</span>
											</translatable>
											<div class="row">
												<div class="col-sm-12 col-md-12">
													<span
														:class="['bmd-form-group mb-1 d-block', $v.product.attis_cg_TNVED.$error ? 'has-danger label-floating' : '', tnved_focused ? 'focused' : '']">
														<tnved :placeholder="$t('message.contracts.product_sku')"
															:placeholder_name="$t('message.tnved_name')"
															:placeholder_code="$t('message.tnved_code')"
															v-model="product.attis_cg_TNVED"></tnved>
														<!-- <v-select id="contract_status" :options="tnveds" label="display_text" :class="['form-control', product.attis_cg_TNVED!==''?'vs--selected':'']" @search="fetchTNVED"  v-model="product.attis_cg_TNVED" :placeholder="$t('message.contracts.product_sku')" @focus="tnvedFocused" @blur="tnvedBlurred"></v-select> -->
														<label
															v-if="product_error && !$v.product.attis_cg_TNVED.required"
															class="control-label text-danger">{{
																$t('message.errors.required') }}</label>
													</span>
												</div>
												<!-- <div class="col-sm-12 col-md-2 mb-3">
													<button style="height: 56px; font-size: 14px;"
														@click="showAISearchModal()"
														class="btn btn-lg btn-outline-success w-100 p-0">
														<div class="row px-0 mx-0 text-nowrap justify-content-center">AI
														</div>
													</button>
												</div> -->
											</div>
											<div class="row mb-3">
												<div class="col-md-4">
													<span :class="['bmd-form-group mb-1 d-block']">
														<cleave v-model="product.attis_cg_quantity" :options="cleave"
															class="form-control"
															:placeholder="$t('message.contracts.product_qty')"
															autocomplete="off" style="cursor: auto;">
														</cleave>
													</span>
												</div>
												<div class="col-md-4">
													<span
														:class="['bmd-form-group mb-1 d-block form-label-group', product_focused ? 'focused' : '']">
														<v-select-popup :readonly=is_field_readonly type="measure"
															:placeholder="$t('message.contracts.product_units')"
															v-model="product.attis_cg_measures" />

														<!-- <v-select id="contract_product_measures" :options="measures" label="display_text" :class="['form-control', product.attis_cg_measures!==''?'vs--selected':'']" @search="fetchMeasures"  v-model="product.attis_cg_measures" @focus="product_focused=true" @blue="product_focused=false"></v-select>
														 <label for="contract_product_measures" class="form-label-group-label shorter">{{$t('message.contracts.product_units')}}</label> -->
													</span>
												</div>
												<div class="col-md-4">
													<span :class="['bmd-form-group mb-1 d-block']">
														<cleave v-model="product.attis_cg_price" :options="cleave"
															class="form-control"
															:placeholder="$t('message.contracts.product_unit_price')"
															autocomplete="off" style="cursor: auto;"></cleave>
													</span>
												</div>
											</div>
											<button class="btn btn-sm btn-success" @click="addProduct()"
												v-if="add_product">
												{{ $t('message.contracts.add_product') }}
											</button>
											<button class="btn btn-sm btn-success" @click="saveProduct()"
												v-if="edit_product">
												{{ $t('message.contracts.save_product') }}
											</button>
											<button v-if="add_product"
												class="btn btn-sm btn-danger btn-outline-danger float-right"
												@click="hideAddProduct()">{{ $t('message.cancel') }}</button>
											<button v-if="edit_product"
												class="btn btn-sm btn-danger btn-outline-danger float-right"
												@click="hideEditProduct()">{{ $t('message.cancel') }}</button>
										</div>
									</transition>
									<button class="btn btn-sm btn-success btn-outline-success" @click="showAddProduct()"
										v-if="!add_product && !edit_product && !is_field_readonly">
										{{ $t('message.contracts.add_product') }}
									</button>
									<div class="float-md-right pt-2" v-if="!add_product && !edit_product">
										{{ $t('message.contracts.contract_amount') }}: {{ amount() }}
										{{ attis_contracts.attis_contract_currency.display_text }}
									</div>
									<br><br>

									<!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group', placeholder_delivery?'placeholderStatus':'', delivery_focused?'focused':'']">
										
					                    <v-select id="contract_delivery_terms" :options="delivery_terms" label="display_text" :class="['form-control', attis_contracts.attis_contract_delivery_term.value!==''?'vs--selected':'']" @search="fetchDeliveryTerms"  v-model="attis_contracts.attis_contract_delivery_term" :placeholder="$t('message.contracts.conditions')" @focus="deliveryFocused" @blur="deliveryBlurred"></v-select>
					                    <label for="contract_delivery_terms" class="form-label-group-label shorter">{{$t('message.contracts.conditions')}}</label>
									</span> -->
									<!-- <code-value :readonly=is_field_readonly :label="$t('message.contracts.conditions')" :value_placeholder="$t('message.contracts.conditions')" :code_placeholder="$t('message.contracts.conditions_code')" type="delivery_term" v-model="attis_contracts.attis_contract_delivery_term" ></code-value> -->

									<v-select-popup :readonly=is_field_readonly type='delivery_term'
										v-model="attis_contracts.attis_contract_delivery_term"
										:placeholder="$t('message.contracts.conditions')" />
									<!-- <div class="row">
										<div class="col-md-6">
											<span :class="['bmd-form-group mb-2 d-block']">
							                   	<b-form-datepicker :locale="locale" v-model="attis_contracts.attis_contract_date" :placeholder="$t('message.contracts.term')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker>
											</span>
										</div>
									</div> -->
									<!-- <code-value :readonly=is_field_readonly :label="$t('message.contracts.payment_conditions')" :value_placeholder="$t('message.contracts.payment_conditions')" :code_placeholder="$t('message.contracts.payment_conditions_code')" type="payment_type" v-model="attis_contracts.attis_contract_payment_type" ></code-value> -->

									<v-select-popup :readonly=is_field_readonly type='payment_type'
										v-model="attis_contracts.attis_contract_payment_type"
										:placeholder="$t('message.contracts.payment_conditions')" />
									<!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group',  contragent_focused?'focused':'']">
                                         <v-select :readonly=is_field_readonly id="contract_contragent" :options="companies" label="display_text" :class="['form-control', attis_contracts.attis_contract_contragent.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="attis_contracts.attis_contract_contragent" :placeholder="$t(attis_contracts.attis_contract_type?'message.contracts.seller':'message.contracts.buyer')" @focus="contragFocused" @blur="contragBlurred"></v-select>
                                         <label for="contract_contragent" class="form-label-group-label shorter">{{$t(attis_contracts.attis_contract_type?'message.contracts.seller':'message.contracts.buyer')}}</label>
                                     </span> -->
									<div class="row">
										<div :class="[attis_contracts.attis_contract_contragent.value != '' ? 'col-8' : 'col-10 col-lg-11']"
											id="attis_contract_contragent">
											<v-select-popup :readonly=is_field_readonly type='company'
												v-model="attis_contracts.attis_contract_contragent"
												:placeholder="$t(attis_contracts.attis_contract_type ? 'message.contracts.seller' : 'message.contracts.buyer')" />
										</div>
										<div class="col-2 col-lg-1">
											<button @click="$bvModal.show('modal-add-new_user')"
												class="btn btn-lg px-0 btn-outline-info w-100">
												<i class="fa fa-plus"></i>
											</button>
										</div>
										<div class="col-3" v-if="attis_contracts.attis_contract_contragent.value != ''">

											<button :disabled=is_field_readonly
												class="btn btn-lg px-0 text-small btn-outline-success w-100"
												@click="checkContragent">{{ $t(attis_contracts.attis_contract_type ?
													'message.contracts.check_seller' :
													'message.contracts.check_buyer') }}</button>
										</div>
									</div>
									<span :class="['bmd-form-group mb-2 d-block form-label-group']">
										<datepicker @focus="attis_contracts.attis_contract_deadline = ' '"
											value-type="YYYY-MM-DD" format="DD.MM.YYYY"
											@blur="(attis_contracts.attis_contract_deadline == ' ') ? attis_contracts.attis_contract_deadline = '' : attis_contracts.attis_contract_deadline = attis_contracts.attis_contract_deadline"
											inputClass="form-control" :disabled=is_field_readonly
											v-model="attis_contracts.attis_contract_deadline"
											:placeholder="$t('message.contracts.attis_contract_deadline')"
											:inputAttr="{ id: 'attis_contract_deadline' }" />
										<label for="attis_contract_deadline" class="form-label-group-label shorter"
											:class="(attis_contracts.attis_contract_deadline != '' && attis_contracts.attis_contract_deadline != null) ? 'topped' : ''">{{
												$t('message.contracts.attis_contract_deadline') }}</label>


										<!-- <b-form-datepicker :readonly=is_field_readonly :locale="locale" v-model="attis_contracts.attis_contract_deadline" :placeholder="$t('message.contracts.attis_contract_deadline')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker>
					                   <label for="attis_contract_deadline"   v-if="attis_contracts.attis_contract_deadline!=''"  class="form-label-group-label shorter topped">{{$t('message.contracts.attis_contract_deadline')}}</label> -->
									</span>
									<b-button v-b-toggle.conditions variant="outline-success" size="sm">{{
										$t('message.contracts.conditions_tab')
									}}</b-button>
									<b-collapse id="conditions" class="mt-2 pt-2">
										<h5>{{ $t('message.contracts.attis_contract_conditions_product_and_delivery') }}
										</h5>
										<div class="row">
											<div class="col-sm-12 col-md-4">
												<span
													:class="['bmd-form-group mb-2 d-block form-label-group', country_focused ? 'focused' : '']">
													<v-select-popup :readonly=is_field_readonly type="country"
														v-model="attis_contract_conditions.goods_origin_country"
														:placeholder="$t('message.contracts.attis_contract_conditions_goods_origin_country')" />
												</span>
											</div>
											<div class="col-sm-12 col-md-4">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input :readonly=is_field_readonly type="text" class="form-control"
														v-model="attis_contract_conditions.point_of_departure"
														:placeholder="$t('message.contracts.attis_contract_conditions_point_of_departure')"
														autocomplete="off" style="cursor: auto;"
														id="attis_contract_conditions_point_of_departure">
													<label for="attis_contract_conditions_point_of_departure"
														class="form-label-group-label shorter">{{
															$t('message.contracts.attis_contract_conditions_point_of_departure')
														}}</label>
												</span>
											</div>
											<div class="col-sm-12 col-md-4">
												<span class="bmd-form-group mb-2 d-block form-label-group">
													<input :readonly=is_field_readonly type="text" class="form-control"
														v-model="attis_contract_conditions.destination_point"
														:placeholder="$t('message.contracts.attis_contract_conditions_destination_point')"
														autocomplete="off" style="cursor: auto;"
														id="attis_contract_conditions_destination_point">
													<label for="attis_contract_conditions_destination_point"
														class="form-label-group-label shorter">{{
															$t('message.contracts.attis_contract_conditions_destination_point')
														}}</label>
												</span>
											</div>
										</div>
										<div class="row">
											<div v-if="!is_field_readonly" class="col-12 bmd-form-group mb-2 d-block">
												<label for="attis_contract_conditions_quality_doc">{{
													$t('message.contracts.attis_contract_conditions_quality_doc')
												}}</label>
												<input id="attis_contract_conditions_quality_doc" type="file"
													@change="attachQualityDocFile($event)" class="form-control">
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<div
													class="togglebutton other mt-md-3 form-label-group single-option-toggle-small">
													<label class="control-label">
														<input :disabled=is_field_readonly type="checkbox"
															v-model="attis_contract_conditions.packaging_transport_fees_included">
														<span class="toggle"></span>
														<span class="choise_2 text-nowrap">{{
															$t('message.contracts.attis_contract_conditions_packaging_transport_fees_included')
														}}</span>
													</label>
												</div>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_shipping_term"
														:class="['form-label-group-label shorter', attis_contract_conditions.shipping_term != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_shipping_term')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.shipping_term"
														:options="cleave" id="attis_contract_conditions_shipping_term"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_shipping_term')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_days_to_receive_goods"
														:class="['form-label-group-label shorter', attis_contract_conditions.days_to_receive_goods != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_days_to_receive_goods')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.days_to_receive_goods"
														:options="cleave"
														id="attis_contract_conditions_days_to_receive_goods"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_days_to_receive_goods')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_shipping_overdue"
														:class="['form-label-group-label shorter', attis_contract_conditions.shipping_overdue != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_shipping_overdue')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.shipping_overdue"
														:options="cleave"
														id="attis_contract_conditions_shipping_overdue"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_shipping_overdue')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
												<small style="display:block; margin-top: -20px;">
													{{
														$t('message.contracts.attis_contract_conditions_shipping_overdue_description')
													}}
												</small>
											</div>
										</div>
										<div class="row mt-3">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_decline_due_to_overdue"
														:class="['form-label-group-label shorter', attis_contract_conditions.decline_due_to_overdue != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_decline_due_to_overdue')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.decline_due_to_overdue"
														:options="cleave"
														id="attis_contract_conditions_decline_due_to_overdue"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_decline_due_to_overdue')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_guarantee_term"
														:class="['form-label-group-label shorter', attis_contract_conditions.guaranty_term != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_guarantee_term')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.guaranty_term"
														:options="cleave" id="attis_contract_conditions_guarantee_term"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_guarantee_term')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-12">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_not_accept_fine"
														:class="['form-label-group-label shorter', attis_contract_conditions.not_accept_fine != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_not_accept_fine')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.not_accept_fine"
														:options="cleave" id="attis_contract_conditions_not_accept_fine"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_not_accept_fine')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<hr>
										<h5>{{ $t('message.contracts.attis_contract_conditions_payment') }}</h5>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_number_of_days_for_prepayment"
														:class="['form-label-group-label shorter', attis_contract_conditions.number_of_days_for_prepayment != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_number_of_days_for_prepayment')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.number_of_days_for_prepayment"
														:options="cleave"
														id="attis_contract_conditions_number_of_days_for_prepayment"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_number_of_days_for_prepayment')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_prepayment_percent"
														:class="['form-label-group-label shorter', attis_contract_conditions.prepayment_percent != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_prepayment_percent')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.prepayment_percent"
														:options="cleave"
														id="attis_contract_conditions_prepayment_percent"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_prepayment_percent')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_payment_overdue"
														:class="['form-label-group-label shorter', attis_contract_conditions.payment_overdue != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_payment_overdue')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.payment_overdue"
														:options="cleave" id="attis_contract_conditions_payment_overdue"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_payment_overdue')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
												<small style="display:block; margin-top: -20px;">
													{{
														$t('message.contracts.attis_contract_conditions_payment_overdue_description')
													}}
												</small>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label
														for="attis_contract_conditions_number_of_days_for_fullpayment"
														:class="['form-label-group-label shorter', attis_contract_conditions.number_of_days_for_fullpayment != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_number_of_days_for_fullpayment')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.number_of_days_for_fullpayment"
														:options="cleave"
														id="attis_contract_conditions_number_of_days_for_fullpayment"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_number_of_days_for_fullpayment')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<div class="row mt-3">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_opening_letter_deadline"
														:class="['form-label-group-label shorter', attis_contract_conditions.opening_letter_deadline != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_opening_letter_deadline')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.opening_letter_deadline"
														:options="cleave"
														id="attis_contract_conditions_opening_letter_deadline"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_opening_letter_deadline')"
														autocomplete="off" style="cursor: auto;"></cleave>
													<small style="display:block;">
														{{
															$t('message.contracts.attis_contract_conditions_opening_letter_deadline_description')
														}}
													</small>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_docs_deadline_after_letter"
														:class="['form-label-group-label shorter', attis_contract_conditions.docs_deadline_after_letter != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_docs_deadline_after_letter')
														}}</label>
													<cleave :readonly=is_field_readonly
														v-model="attis_contract_conditions.docs_deadline_after_letter"
														:options="cleave"
														id="attis_contract_conditions_docs_deadline_after_letter"
														class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_docs_deadline_after_letter')"
														autocomplete="off" style="cursor: auto;"></cleave>
													<small style="display:block;">
														{{
															$t('message.contracts.attis_contract_conditions_docs_deadline_after_letter_description')
														}}
													</small>
												</span>
											</div>
										</div>
										<div class="row mt-1">
											<div class="col-12">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input :readonly=is_field_readonly type="text" class="form-control"
														v-model="attis_contract_conditions.letter_payment_documents"
														:placeholder="$t('message.contracts.attis_contract_conditions_letter_payment_documents')"
														autocomplete="off" style="cursor: auto;"
														id="attis_contract_conditions_letter_payment_documents">
													<label for="attis_contract_conditions_letter_payment_documents"
														class="form-label-group-label shorter">{{
															$t('message.contracts.attis_contract_conditions_letter_payment_documents')
														}}</label>
													<small style="display:block;">
														{{
															$t('message.contracts.attis_contract_conditions_letter_payment_documents_description')
														}}
													</small>
												</span>
											</div>
										</div>
										<hr>
										<h5>{{ $t('message.contracts.attis_contract_conditions_contract_details') }}
										</h5>
										<div class="row">
											<div class="col-sm-12 col-md-4">
												<span
													:class="['bmd-form-group mb-2 d-block form-label-group', placeholder_currency ? 'placeholderStatus' : '', language_focused ? 'focused' : '']">
													<v-select-popup :indata="languagesPairs"
														v-model="attis_contract_conditions.contract_language"
														:placeholder="$t('message.contracts.attis_contract_conditions_contract_language')"
														:readonly=is_field_readonly />
												</span>
											</div>
											<div class="col-sm-12 col-md-4">
												<span
													:class="['bmd-form-group mb-2 d-block form-label-group', placeholder_currency ? 'placeholderStatus' : '', language_focused ? 'focused' : '']">
													<v-select-popup :indata="languages"
														v-model="attis_contract_conditions.default_lang"
														:placeholder="$t('message.contracts.attis_contract_conditions_default_lang')"
														:readonly=is_field_readonly />
												</span>
											</div>
											<div class="col-sm-12 col-md-4">
												<span
													:class="['bmd-form-group mb-1 d-block  form-label-group', arbitrage_country_focused ? 'focused' : '']">
													<v-select-popup type="country"
														v-model="attis_contract_conditions.arbitrage_country"
														:placeholder="$t('message.contracts.attis_contract_conditions_arbitrage_country')"
														:readonly=is_field_readonly />
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input :readonly=is_field_readonly type="text" class="form-control"
														v-model="attis_contract_conditions.place_of_detention"
														:placeholder="$t('message.contracts.attis_contract_conditions_place_of_detention')"
														autocomplete="off" style="cursor: auto;"
														id="attis_contract_conditions_place_of_detention">
													<label for="attis_contract_conditions_place_of_detention"
														class="form-label-group-label shorter">{{
															$t('message.contracts.attis_contract_conditions_place_of_detention')
														}}</label>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-2 d-block form-label-group']">
													<datepicker value-type="YYYY-MM-DD" format="DD.MM.YYYY"
														@focus="attis_contract_conditions.contract_term = ' '"
														@blur="(attis_contract_conditions.contract_term == ' ') ? attis_contract_conditions.contract_term = '' : attis_contract_conditions.contract_term = attis_contract_conditions.contract_term"
														inputClass="form-control" :disabled=is_field_readonly
														v-model="attis_contract_conditions.contract_term"
														:placeholder="$t('message.contracts.attis_contract_conditions_contract_term')"
														:inputAttr="{ id: 'attis_contract_conditions_contract_term' }" />
													<label for="attis_contract_conditions_contract_term"
														class="form-label-group-label shorter"
														:class="(attis_contract_conditions.contract_term != '' && attis_contract_conditions.contract_term != null) ? 'topped' : ''">{{
															$t('message.contracts.attis_contract_conditions_contract_term')
														}}</label>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input :readonly=is_field_readonly type="text" class="form-control"
														v-model="attis_contract_conditions.seller_basis"
														:placeholder="$t('message.contracts.attis_contract_conditions_seller_basis')"
														autocomplete="off" style="cursor: auto;"
														id="attis_contract_conditions_seller_basis">
													<label for="attis_contract_conditions_seller_basis"
														class="form-label-group-label shorter">{{
															$t('message.contracts.attis_contract_conditions_seller_basis')
														}}</label>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input :readonly=is_field_readonly type="text" class="form-control"
														v-model="attis_contract_conditions.buyer_basis"
														:placeholder="$t('message.contracts.attis_contract_conditions_buyer_basis')"
														autocomplete="off" style="cursor: auto;"
														id="attis_contract_conditions_buyer_basis">
													<label for="attis_contract_conditions_buyer_basis"
														class="form-label-group-label shorter">{{
															$t('message.contracts.attis_contract_conditions_buyer_basis')
														}}</label>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span class="bmd-form-group mb-2 d-block form-label-group">
													<input :readonly=is_field_readonly type="text" class="form-control"
														v-model="attis_contract_conditions.buyer_full_name"
														:placeholder="$t('message.contracts.attis_contract_conditions_buyer_full_name')"
														autocomplete="off" style="cursor: auto;"
														id="attis_contract_conditions_buyer_full_name">
													<label for="attis_contract_conditions_buyer_full_name"
														class="form-label-group-label shorter">{{
															$t('message.contracts.attis_contract_conditions_buyer_full_name')
														}}</label>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span class="bmd-form-group mb-2 d-block form-label-group">
													<input :readonly=is_field_readonly type="text" class="form-control"
														v-model="attis_contract_conditions.seller_full_name"
														:placeholder="$t('message.contracts.attis_contract_conditions_seller_full_name')"
														autocomplete="off" style="cursor: auto;"
														id="attis_contract_conditions_seller_full_name">
													<label for="attis_contract_conditions_seller_full_name"
														class="form-label-group-label shorter">{{
															$t('message.contracts.attis_contract_conditions_seller_full_name')
														}}</label>
												</span>
											</div>
										</div>
									</b-collapse>
									<br><br>
									<div class="d-block files-block">
										<label>{{ $t('message.contracts.attachements') }}</label>
										<div class="file-o" v-for="(file, index) in files" :key="index">
											<div class="row">
												<div class="col-11">
													<a target=_blank :href="'/Picture/GetTxtFile/' + file.id">{{
														file.name }} <i class="fas fa-arrow-down"></i></a>
												</div>
												<div class="col-1">
													<button v-if="!is_field_readonly"
														class="btn btn-sm btn-link text-danger"
														@click="deleteFile(file, index)"><i
															class="fa fa-trash"></i></button>
												</div>

											</div>
										</div>
										<div v-for="(file, index) in files_att"
											class="row align-items-center border-bottom mb-4 pb-4" :key="'upl' + index">
											<div class="col-6">
												<input :disabled="files_loading" type="file"
													@change="attachFile($event, index)" class="mb-2" />
											</div>
											<div class="col-6">
												<v-select-popup type="attach_doc_types" placeholder="Document type"
													@input="$event => attachFileType($event, index)" />
											</div>
											<div class="col-6">
												<DateInput :disabled="files_loading" value="" placeholder="Date"
													@input="attachFileDate($event, index)" class="mb-2" />
											</div>
											<div class="col-6">
												<TextInput :disabled="files_loading" placeholder="Reference Number"
													@input="attachFileReference($event, index)" class="mb-2" />
											</div>
											<div class="col-6">
												<button class="btn btn-sm btn-danger text-white"
													@click="removeFile(index)">
													&times; Remove file
												</button>
											</div>
										</div>
										<div v-if="!is_field_readonly">
											<button class="btn btn-sm btn-outline-success" @click="addAttachement">{{
												$t('message.contracts.add_attachement') }}</button>
											<br>
											<small><i>{{ $t('message.contracts.add_attachement_info') }}</i></small>
										</div>
									</div>

									<div
										class="text-center mb-2 mt-4 d-md-flex align-items-center justify-content-between">
										<div class="btn-group">
											<button v-if="!is_field_readonly"
												class="btn btn-outline-success btn-round float-md-left btn-sm"
												@click="current_tab = 1">{{ $t('message.contracts.find_partner')
												}}</button>
											<button v-if="!is_field_readonly"
												:class="['btn btn-success btn-sm btn-round', loading ? 'pl-5' : '', form_error ? 'btn-danger' : '']"
												@click.prevent.stop="submit">
												<div class="loading my-1 loading-button" v-if="loading"></div>
												{{ $t('message.contracts.submit_button') }}<div
													class="ripple-container">
												</div>
											</button>
											<button id="submit_and_sign_button" v-if="!is_field_readonly"
												:class="['btn btn-outline-success btn-sm btn-round', loading ? 'pl-5' : '', form_error ? 'btn-danger' : '']"
												:disabled="can_sign_contract"
												@click.prevent.stop="submit_and_sign_dialog">
												<div class="loading my-1 loading-button" v-if="loading"></div>
												{{ $t('message.contracts.submit_and_sign_button') }}<div
													class="ripple-container"></div>
											</button>
											<button v-if="is_counterparty_to_sign"
												:class="['btn btn-outline-success btn-sm btn-round', loading ? 'pl-5' : '', form_error ? 'btn-danger' : '']"
												@click.prevent.stop="submit_and_sign_dialog">
												<div class="loading my-1 loading-button" v-if="loading"></div>
												{{ $t('message.contracts.contract_sign') }}<div
													class="ripple-container">
												</div>
											</button>
										</div>
										<pdf v-if="is_deal || (attis_contracts.is_signed_by_owner && attis_contracts.is_signed_by_counterparty)"
											:document=attis_contracts :goods=attis_contract_goods
											:user_id=attis_contracts.attis_contract_owner
											:doc_id=attis_contracts.attis_contract_id
											:doc_additional=attis_contract_conditions source='contract'></pdf>
										<!-- <button class="btn btn-info btn-round" @click="accept_contract" v-if="can_accept">{{$t('message.contracts.offer_accept')}}</button> -->
										<!-- <button class="btn btn-info btn-round" @click="sign_contract" v-if="can_sign">{{$t('message.contracts.contract_sign')}}</button> -->

										<!-- <button :class="['btn btn-info btn-round', ktg_loading?'pl-5':'']" @click.prevent.stop="ktg"><div class="loading my-1 loading-button" v-if="ktg_loading"></div> {{$t('message.contracts.submit_ktg')}}<div class="ripple-container"></div></button> -->
										<button class="btn btn-outline-danger btn-round float-right btn-sm mt-4 mt-lg-0"
											@click="cancelContract">{{
												$t('message.cancel') }}</button>
									</div>
								</b-tab>
								<b-tab :title="$t('message.contracts.contragents_tab')" lazy id="contragents-tab">
									<contracts-contragents-search
										:contract_id="$route.params.id"></contracts-contragents-search>
								</b-tab>
								<b-tab :title="$t('message.contracts.offers_tab')" lazy id="offers-tab">
									<div class="row">
										<div class="col-12">
											<div
												class="togglebutton other mt-md-3 form-label-group single-option-toggle-small">
												<label class="control-label">
													<!--<span>{{$t('message.contracts.type')}}</span><br><br>-->
													<input type="checkbox" v-model="show_declined">
													<span class="toggle"></span>
													<span class="choise_2 text-nowrap">{{
														$t('message.contracts.offers_show_declined') }}</span>
												</label>
											</div>
										</div>
									</div>

									<b-table responsive :tbody-tr-class="rowClass" :fields="offer_fields"
										:items="filtered_offers_list" @row-clicked=showModalOffer>
										<template v-slot:cell(contract_date)="data">
											{{ momentum(data.value) }}
										</template>
										<template v-slot:cell(buttons)="data">
											<div class="text-right">
												<button class="btn btn-link"
													@click="showModalOffer(data.item, data.index)"><i
														class="fa fa-search"></i></button>
												<button v-if="data.item.status !== 1" class="btn btn-link text-danger"
													@click="removeOffer(data.index)"><i
														class="fa fa-trash"></i></button>
											</div>
										</template>

									</b-table>
									<b-button v-if="!is_owner && !offer_is_accepted && can_add_offer"
										variant="outline-success" size="sm" @click="add_offer()">
										<!--v-if="!is_owner && !is_deal"-->
										{{ $t('message.contracts.offer_new') }}
									</b-button>
									<b-modal id="modal-offer-new" size="lg" :title="$t('message.contracts.offer_new')"
										:hide-footer=true button-size="lg">
										<offer-new></offer-new>
									</b-modal>
									<b-modal id="modal-offer" size="lg" :title="$t('message.contracts.single_offer')"
										button-size="lg">
										<offer-single :offer=opened_offer></offer-single>
										<template v-slot:modal-footer="{ }">
											<!-- Emulate built in modal footer ok and cancel button actions -->
											<b-button class="mr-auto"
												v-if="!opened_offer.no_changes && opened_offer.status !== 1"
												variant="outline-danger" @click="answer(opened_offer)">
												{{ $t('message.contracts.offer_answer') }}
											</b-button>
											<b-button class="mr-auto"
												v-if="!opened_offer.no_changes && opened_offer.can_show_chain"
												variant="outline-danger" @click="showChain(opened_offer)">
												<span>{{ $t('message.contracts.offer_show_chain_answer') }}</span>
											</b-button>
											<b-button v-if="opened_offer.status !== 1" variant="success" class="mr-5"
												@click="accept(opened_offer)">
												{{ $t('message.contracts.offer_accept') }}
											</b-button>
											<!-- Button with custom close trigger value -->
											<b-button v-if="opened_offer.status !== 1" variant="danger"
												@click="decline(opened_offer)">
												{{ $t('message.contracts.offer_decline') }}
											</b-button>
										</template>
									</b-modal>
									<b-modal id="modal-answer" size="lg"
										:title="$t('message.contracts.offer_answer_title')">
										<span :class="['bmd-form-group mb-2 d-block form-label-group required']">
											<offer-single :offer=opened_offer_answer :is_answer="true"></offer-single>
											<!-- <textarea class="form-control" v-model="opened_offer.answer_text" :placeholder="$t('message.contracts.offer_answer_text')" autocomplete="off" style="cursor: auto;" id="single_offer_answer_text"></textarea> -->
											<!--<label for="single_offer_country" class="form-label-group-label shorter">{{$t('message.contracts.offer')}}</label>-->
										</span>
										<template v-slot:modal-footer="{ }">
											<!-- Emulate built in modal footer ok and cancel button actions -->
											<b-button variant="success" class="mr-5"
												@click="sendAnswer(opened_offer_answer)">
												{{ $t('message.contracts.offer_answer_send') }}
											</b-button>
											<b-button class="mr-auto" variant="outline-danger"
												v-if="opened_offer_answer.can_show_chain"
												@click="showChain(opened_offer)">
												<span>{{ $t('message.contracts.offer_show_chain_answer') }}</span>
											</b-button>
											<!-- Button with custom close trigger value -->
											<b-button variant="danger" @click="cancel()">
												{{ $t('message.cancel') }}
											</b-button>
										</template>
									</b-modal>
									<b-modal id="modal-chain" hide-footer size="lg"
										:title="$t('message.contracts.offer_chain_title')">
										<div v-if="!show_current_chain">

											<div class="table-responsive">
												<table
													class="table email-table no-wrap table-hover v-middle mb-0 font-14">
													<tbody>
														<tr v-for="(item, i) in opened_offer.chain" :key="i"
															@click="show_more_in_chain(i)">
															<td>{{ item.attis_contract_offer_change_user.org_name }}
															</td>
															<td :title="item.attis_contract_offer_change_date">
																{{ item.attis_contract_offer_change_date }}
															</td>
															<td>
																<div
																	v-if="item.attis_contract_offer_answer.length > 20">
																	<span>{{
																		item.attis_contract_offer_answer.substring(0,
																			20) }}</span>
																	<span v-if="uncollapse != i">...</span>
																	<span v-else>{{
																		item.attis_contract_offer_answer.substring(20,
																			item.attis_contract_offer_answer.length)
																	}}</span>
																</div>
																<div v-else>
																	<span>{{ item.attis_contract_offer_answer }}</span>
																</div>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div v-if="show_current_chain">
											<button class="btn btn-secondary"
												@click.prevent.stop="show_current_chain = false">{{ $t('message.back')
												}}</button>
											<div class="email-content">
												<div class="email-head">
													<div
														class="email-head-sender d-flex align-items-center justify-content-between flex-wrap">
														<div class="d-flex align-items-center">
															<div class="sender d-flex align-items-center">
																<span>{{
																	current_offer_chain.attis_contract_offer_change_dateattis_contract_offer_change_user.org_name
																}}</span>
															</div>
														</div>
														<div class="date">
															{{ current_offer_chain.attis_contract_offer_change_date }}
														</div>
													</div>
												</div>
												<div class="email-body">
													{{ $t('message.contracts.delivery_price') }}:
													<strong>{{ current_offer_chain.shipping_cost }}</strong>
													<hr>
													{{ current_offer_chain.attis_contract_offer_change_text }}
												</div>
											</div>
										</div>
									</b-modal>
								</b-tab>
								<b-tab :title="$t('message.contracts.couriers_tab')" lazy id="couriers-tab">
									<contracts-couriers-search :is_deal=is_deal :can_add=can_send_offer
										:is_owner=is_owner :roles=user_role
										:contract_id="$route.params.id"></contracts-couriers-search>
								</b-tab>
								<b-tab :title="$t('message.contracts.brokers_tab')" lazy id="brokers-tab">
									<contracts-brokers-search :is_deal=is_deal :can_add=can_send_offer
										:is_owner=is_owner :roles=user_role :contract_id="$route.params.id"
										:products="attis_contract_goods"
										:currency="attis_contracts.attis_contract_currency"></contracts-brokers-search>
								</b-tab>
								<b-tab :title="$t('message.contracts.exim')" lazy
									v-if="is_deal || (attis_contracts.is_signed_by_owner && attis_contracts.is_signed_by_counterparty)"
									id="exim-tab">
									<contracts-exim :is_owner="is_owner"
										:contract_id='$route.params.id'></contracts-exim>
								</b-tab>
								<b-tab :title="$t('message.contracts.documents_tab')" lazy id="docs-tab">
									<!-- v-if="is_deal || (attis_contracts.is_signed_by_owner && attis_contracts.is_signed_by_counterparty)" -->
									<div class="row">
										<div class="col-md-4">
											<div class="list-group border rounded py-0 mb-3">
												<button v-for="(item, ii) in document_categories" :key=ii
													:class="['list-group-item', 'list-group-item-action', current_docs_category == item.value ? 'active' : '', ii == 0 ? 'rounded-top' : '', ii == document_categories.length - 1 ? 'rounded-bottom' : '']"
													@click="loadDocuments(item.value)">{{ item.display_text }}</button>
											</div>
											<button class="btn btn-success btn-round btn-sm" id="add-document-button"
												v-if="!add_document" @click=addDocument>{{
													$t('message.contracts.add_file') }}</button>
											<button class="btn btn-sm btn-outline-danger" v-if="add_document"
												@click="unAddDocument">{{
													$t('message.cancel') }}</button>
										</div>
										<div class="col-md-8">
											<file-list :contract=$route.params.id :category=current_docs_category
												v-if="!add_document" :goods=attis_contract_goods
												:contract_details=attis_contracts></file-list>
											<b-modal id="modal-document-new" size="lg" :hide-footer=true
												:title="$t('message.contracts.new_document')" button-size="lg"
												:no-close-on-backdrop=true>
												<file-new :goods=attis_contract_goods
													:contract_details=attis_contracts></file-new>
											</b-modal>

										</div>
									</div>
								</b-tab>
								<b-tab :title="$t('message.contracts.history_tab')" lazy>
									<b-table responsive :tbody-tr-class="rowClass" :fields="history_fields"
										:items="history_list" @row-clicked=showModalOffer>
										<!-- <template v-slot:cell(contract_date)="data">
											{{momentum(data.value)}}
										</template>
										<template v-slot:cell(buttons)="data">
											<div class="text-right"> -->
										<!--<button class="btn btn-sm btn-danger btn-round" @click="removeOffer(data.item, data.index)"><i class="fa fa-trash"></i></button>-->
										<!--<button class="btn btn-sm btn-info btn-round" @click="showModalOffer(data.item, data.index)"><i class="fa fa-eye"></i></button>
											</div>
										</template> -->
										<template v-slot:cell(buttons)="data">
											<button class="btn btn-link" @click="show_history_json(data)"><i
													class="fa fa-search"></i></button>
										</template>
									</b-table>
								</b-tab>
							</b-tabs>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal id="modal-select-ecp-type" :hide-footer=true size="sm"
			:title="$t('message.contracts.select_ecp_type')">
			<div class="text-center" v-if="!show_code_sign_type">
				<button class="btn btn-outline-success btn-round" @click="submit_and_sign()">
					{{ $t('message.contracts.sign_with_ecp') }}
				</button>
				<div>
					<small>
						<i>
							{{ $t('message.contracts.only_for_kz') }}
						</i>
					</small>
				</div>
				<hr>
				<button class="btn btn-outline-success btn-round" @click="sign_with_code()">
					{{ $t('message.contracts.sign_with_code') }}
				</button>
			</div>
			<div class="text-center" v-if="show_code_sign_type">
				<div class="form-group">
					<label for="input-code">
						{{ $t('message.contracts.input_signature_code') }}
					</label>
					<input type="text" class="form-control" id="input-code" v-model="sign_with_code_code">
				</div>
				<button class="btn btn-success btn-round"
					:class="['btn btn-success btn-round', loading_sign ? 'pl-5' : '']"
					:disabled="sign_with_code_code.length == 0" @click="sign_with_code_phase2()">
					<div class="loading my-1 loading-button" v-if="loading_sign"></div>
					{{ $t('message.contracts.sign_with_code') }}
				</button>
				<hr>
				<button class="btn btn-default btn-round btn-sm" @click="show_code_sign_type = false">{{
					$t('message.cancel')
				}}</button>
			</div>
		</b-modal>
		<b-modal id="modal-add-new_user" :hide-footer=true size="sm"
			:title="($t('message.contracts.add_' + (attis_contracts.attis_contract_type ? 'seller' : 'buyer')))"
			button-size="lg">
			<buyer-seller-form :type="attis_contracts.attis_contract_type ? 'seller' : 'buyer'"></buyer-seller-form>
		</b-modal>
		<b-modal id="show_history_details" :title="$t('message.contracts.contract_history_data')" :hide-footer=true>
			<json-viewer :value="json_data"></json-viewer>
		</b-modal>
		<b-modal id="ai-search-modal" :hide-footer=true size="lg" :title="($t('message.contracts.ai_search'))">
			<div class="form-group d-flex flex-column">
				<textarea class="form-control" id="ai-search-modal-text-area" rows="3"
					v-model="ai_search.ai_search_input"></textarea>
				<div class="row mt-2 justify-content-end">
					<button @click="AISearchCancel()"
						class="btn btn-lg btn-outline-danger p-0 d-flex justify-content-center align-items-center"
						style="height: 40px; font-size: 14px; width: 150px;">
						{{ $t('message.cancel') }}
					</button>
					<button :disabled="ai_search.ai_search_button_disabled"
						class="btn btn-lg btn-outline-success p-0 ml-2 mr-3 d-flex justify-content-center align-items-center"
						@click="AISearch()" style="height: 40px; font-size: 14px; width: 150px;">
						<svg v-if="ai_search.ai_search_button_disabled" aria-hidden="true" focusable="false"
							data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16 "
							style="width: 20px; height: 20px; animation: loader-rotate 1s linear infinite" role="img"
							xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
							<path fill="currentColor"
								d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z">
							</path>
						</svg>
						<div v-else class="row px-0 mx-0 text-nowrap">
							{{ $t('message.contracts.run') }}
						</div>
					</button>
				</div>
			</div>
			<div>
				{{ ai_search.ai_search_results }}
			</div>
		</b-modal>
	</div>
</template>
<script>
var querystring = require('querystring');
import FileUpload from 'vue-upload-component'
import { required } from 'vuelidate/lib/validators'
import ClasterSelector from './../fields/claster-selector.vue'
import Contractscourierssearch from './contractscourierssearch.vue'
import moment from 'moment'
import JsonViewer from 'vue-json-viewer'
import { DateInput, TextInput } from '../simplements'
export default {
	name: "contract-single",
	components: { FileUpload, ClasterSelector, Contractscourierssearch, JsonViewer, DateInput, TextInput },
	data() {
		return {
			looking_for_product_number: '',
			files_loading: false,
			loading_sign: false,
			json_data: '',
			show_code_sign_type: false,
			sign_with_code_code: '',
			offer_is_accepted: false,
			perPage: 10,
			show_declined: false,
			currentPage: 1,
			opened_offer: {},
			opened_offer_answer: {},
			uncollapse: -1,
			show_chain: false,
			search_loading: false,
			can_show_chain: false,
			can_add_offer: true,
			offers_list: [

			],
			offer_fields: [
				{
					key: "buttons",
					label: ''
				},
				{
					key: "ID",
					label: ''
				},
				{
					key: "name",
					label: this.$t('message.contracts.offer_from')
				},
				{
					key: "target_name",
					label: this.$t('message.contracts.offer_target_name')
				},
				{
					key: "offer",
					label: this.$t('message.contracts.offer')
				},
				{
					key: "discount_percents",
					label: this.$t('message.contracts.invoice_products_DiscountPercentage')
				},
				{
					key: "discount_amount",
					label: this.$t('message.contracts.invoice_products_Discount')
				},
				{
					key: "contract_date",
					label: this.$t('message.contracts.contract_date')
				},

			],
			history_list: [
			],
			history_fields: [
				{
					key: "buttons",
					label: ''
				},
				{
					key: "action_created_by",
					label: this.$t('message.contracts.history_action_created_by')
				},
				{
					key: "action_type",
					label: this.$t('message.contracts.history_action_type')
				},
				{
					key: "action_date",
					label: this.$t('message.contracts.history_action_date')
				},

			],
			files: [],//[{"id":"508","name":"test.rtf"}],
			files_att: [],
			headers: {},
			document_categories: [
				{
					display_text: this.$t('message.contracts.docs_cat_all'),
					value: 'all',
				},
				{
					display_text: this.$t('message.contracts.docs_cat_commerce'),
					value: 'commerce',
				},
				{
					display_text: this.$t('message.contracts.docs_cat_finance'),
					value: 'finance',
				},
				{
					display_text: this.$t('message.contracts.docs_cat_transport'),
					value: 'transport',
				},
				{
					display_text: this.$t('message.contracts.docs_cat_customs'),
					value: 'customs',
				}
			],
			current_docs_category: 'all',
			attis_contracts: {
				attis_contract_owner: '',
				attis_contract_number: '',
				attis_contract_status: {
					value: 1,
					display_text: this.$t('message.contracts.status_1')
				},
				attis_contract_type: false,
				attis_contract_case: false,
				attis_contract_subject: '',
				attis_contract_desc: '',
				attis_contract_currency: { value: '', display_text: '' },
				attis_contract_delivery_term: { value: '', display_text: '' },
				attis_contract_date: '',
				attis_contract_payment_type: { value: '', display_text: '' },
				attis_contract_contragent: { value: '', display_text: '' },
				attis_contract_deadline: '',
				attis_contract_is_public: false,

				is_signed_by_owner: false,
				is_signed_by_counterparty: false,
				when_is_signed_by_owner: '',
				name_of_signature_owner: '',
				how_is_signed_by_owner: '',
				when_is_signed_by_counterparty: '',
				name_of_signature_counterparty: '',
				how_is_signed_by_counterparty: '',
				adb: { value: '', display_text: '' },
			},
			attis_contragents: {
				country: { value: '' },
				city: '',
				sphere: '',
				name: '',
				search_other: false,
			},
			attis_contract_conditions: {
				packaging_transport_fees_included: false,
				goods_origin_country: { value: '' },
				point_of_departure: '',
				destination_point: '',
				prepayment_percent: '',
				number_of_days_for_prepayment: '',
				number_of_days_for_fullpayment: '',
				shipping_term: '',
				days_to_receive_goods: '',
				guaranty_term: '',
				payment_overdue: '',
				shipping_overdue: '',
				decline_due_to_overdue: '',
				arbitrage_country: { value: '' },
				contract_language: { value: '' },
				contract_term: '',
				quality_doc: "",
				not_accept_fine: '',
				opening_letter_deadline: '',
				letter_payment_documents: '',
				docs_deadline_after_letter: '',
				default_lang: { value: '' },
				place_of_detention: '',
				buyer_basis: '',
				seller_basis: '',
				buyer_full_name: '',
				seller_full_name: '',
			},
			country_focused: false,
			arbitrage_country_focused: false,

			params: [
				{
					display_text: 'Param Value',
					value: 'value'
				}
			],
			search_results_fields: [
				{
					key: "id",
					label: this.$t('message.contracts.contragents_search_id')
				},
				{
					key: "country",
					label: this.$t('message.contracts.contragents_search_country')
				},
				{
					key: "name",
					label: this.$t('message.contracts.contragents_search_name')
				},
				{
					key: "email",
					label: this.$t('message.contracts.contragents_search_email')
				},
				{
					key: "contact",
					label: this.$t('message.contracts.contragents_search_contact')
				},
				{
					key: "sphere",
					label: this.$t('message.contracts.contragents_search_sphere')
				},
				{
					key: "checked",
					label: this.$t('message.contracts.contragents_search_checked')
				},
			],
			contragents_search_results: [
			],
			saved_searches_fields: [
				{
					key: 'date',
					label: this.$t('message.contracts.saved_searches_date'),
				},
				{
					key: 'number_results',
					label: this.$t('message.contracts.saved_searches_number_of_results')
				}
			],
			saved_searches: [
			],

			status_focused: false,
			placeholder_status: false,
			product_focused: false,
			currency_focused: false,
			placeholder_currency: false,

			placeholder_delivery: false,
			delivery_focused: false,
			contragent_focused: false,
			contrsearch_country_focus: false,

			payment_focused: false,

			is_send_to_adb: false,
			is_sent_to_adb: true,

			statuses: [
				{
					value: 1,
					display_text: this.$t('message.contracts.status_1')
				},
				{
					value: 2,
					display_text: this.$t('message.contracts.status_2')
				},
				{
					value: 3,
					display_text: this.$t('message.contracts.status_3')
				},
				{
					value: 4,
					display_text: this.$t('message.contracts.status_4')
				}
			],
			history_types: [
				{
					value: 0,
					display_text: this.$t('message.contracts.history_new_contract'),
					section: "Contract"
				},
				{
					value: 1,
					display_text: this.$t('message.contracts.history_contract_update'),
					section: "Contract"
				},
				{
					value: 2,
					display_text: this.$t('message.contracts.history_contract_delete'),
					section: "Contract"
				},
				{
					value: 3,
					display_text: this.$t('message.contracts.history_accept_contract'),
					section: "Contract"
				},
				{
					value: 4,
					display_text: this.$t('message.contracts.history_new_ktg'),
					section: "Contract"
				},
				{
					value: 5,
					display_text: this.$t('message.contracts.history_sftp_download'),
					section: "Contract"
				},
				{
					value: 6,
					display_text: this.$t('message.contracts.history_delete_document'),
					section: "Contract"
				},
				{
					value: 7,
					display_text: this.$t('message.contracts.history_new_broker_contract'),
					section: "Contract"
				},
				{
					value: 8,
					display_text: this.$t('message.contracts.history_update_broker_contract'),
					section: "Contract"
				},
				{
					value: 9,
					display_text: this.$t('message.contracts.history_delete_broker_contract'),
					section: "Contract"
				},
				{
					value: 10,
					display_text: this.$t('message.contracts.history_contract_owner_sign'),
					section: "Contract"
				},
				{
					value: 11,
					display_text: this.$t('message.contracts.history_contract_contragent_sign'),
					section: "Contract"
				},
				{
					value: 0,
					display_text: this.$t('message.contracts.history_new_invoice'),
					section: "Document"
				},
				{
					value: 1,
					display_text: this.$t('message.contracts.history_new_invoice_goods'),
					section: "Document"
				},
				{
					value: 2,
					display_text: this.$t('message.contracts.history_invoice_update'),
					section: "Document"
				},
				{
					value: 3,
					display_text: this.$t('message.contracts.history_new_cmr'),
					section: "Document"
				},
				{
					value: 4,
					display_text: this.$t('message.contracts.history_new_cmr_cargo'),
					section: "Document"
				},
				{
					value: 5,
					display_text: this.$t('message.contracts.history_new_cmr_goods'),
					section: "Document"
				},
				{
					value: 6,
					display_text: this.$t('message.contracts.history_cmr_update'),
					section: "Document"
				},
				{
					value: 7,
					display_text: this.$t('message.contracts.history_new_fm1'),
					section: "Document"
				},
				{
					value: 8,
					display_text: this.$t('message.contracts.history_fm1_update'),
					section: "Document"
				},
				{
					value: 9,
					display_text: this.$t('message.contracts.history_new_epi'),
					section: "Document"
				},
				{
					value: 10,
					display_text: this.$t('message.contracts.history_epi_update'),
					section: "Document"
				},
				{
					value: 11,
					display_text: this.$t('message.contracts.history_new_awb'),
					section: "Document"
				},
				{
					value: 12,
					display_text: this.$t('message.contracts.history_awb_update'),
					section: "Document"
				},
				{
					value: 13,
					display_text: this.$t('message.contracts.history_new_packing_list'),
					section: "Document"
				},
				{
					value: 14,
					display_text: this.$t('message.contracts.history_packing_list_update'),
					section: "Document"
				},
				{
					value: 15,
					display_text: this.$t('message.contracts.history_delete_packing_list'),
					section: "Document"
				},
				{
					value: 16,
					display_text: this.$t('message.contracts.history_new_places'),
					section: "Document"
				},
				{
					value: 17,
					display_text: this.$t('message.contracts.history_places_update'),
					section: "Document"
				},
				{
					value: 18,
					display_text: this.$t('message.contracts.history_delete_places'),
					section: "Document"
				},
				{
					value: 19,
					display_text: this.$t('message.contracts.history_new_RWB'),
					section: "Document"
				},
				{
					value: 20,
					display_text: this.$t('message.contracts.history_update_RWB'),
					section: "Document"
				},
				{
					value: 21,
					display_text: this.$t('message.contracts.history_delete_RWB'),
					section: "Document"
				},
				{
					value: 22,
					display_text: this.$t('message.contracts.history_new_insurance'),
					section: "Document"
				},
				{
					value: 23,
					display_text: this.$t('message.contracts.history_update_insurance'),
					section: "Document"
				},
				{
					value: 24,
					display_text: this.$t('message.contracts.history_delete_insurance'),
					section: "Document"
				},
				{
					value: 25,
					display_text: this.$t('message.contracts.history_new_liability_insurance'),
					section: "Document"
				},
				{
					value: 26,
					display_text: this.$t('message.contracts.history_update_liability_insurance'),
					section: "Document"
				},
				{
					value: 27,
					display_text: this.$t('message.contracts.history_delete_liability_insurance'),
					section: "Document"
				},


				{
					value: 0,
					display_text: this.$t('message.contracts.history_answer_offer'),
					section: "Offer"
				},
				{
					value: 1,
					display_text: this.$t('message.contracts.history_accept_offer'),
					section: "Offer"
				},
				{
					value: 2,
					display_text: this.$t('message.contracts.history_decline_offer'),
					section: "Offer"
				},
				{
					value: 3,
					display_text: this.$t('message.contracts.history_new_offer'),
					section: "Offer"
				},
				{
					value: 4,
					display_text: this.$t('message.contracts.history_sign_offer'),
					section: "Offer"
				},
				{
					value: 5,
					display_text: this.$t('message.contracts.history_delete_offer'),
					section: "Offer"
				},
				{
					value: 6,
					display_text: this.$t('message.contracts.history_new_courier_offer'),
					section: "Offer"
				},
				{
					value: 7,
					display_text: this.$t('message.contracts.history_courier_offer'),
					section: "Offer"
				},
				{
					value: 8,
					display_text: this.$t('message.contracts.history_decline_courier_offer'),
					section: "Offer"
				},
				{
					value: 9,
					display_text: this.$t('message.contracts.history_select_courier_offer'),
					section: "Offer"
				},
				{
					value: 10,
					display_text: this.$t('message.contracts.history_broker_offer'),
					section: "Offer"
				},
				{
					value: 11,
					display_text: this.$t('message.contracts.history_accept_broker_offer'),
					section: "Offer"
				},
				{
					value: 12,
					display_text: this.$t('message.contracts.history_decline_broker_offer'),
					section: "Offer"
				},
				{
					value: 13,
					display_text: this.$t('message.contracts.history_select_broker_offer'),
					section: "Offer"
				},
				{
					value: 14,
					display_text: this.$t('message.contracts.history_new_broker_offer'),
					section: "Offer"
				},



			],
			currencies: [],
			add_product: false,
			edit_product: false,
			product_error: false,
			countries: [],
			loading: false,
			ktg_loading: false,
			status: '',
			list: [],
			cleave: {
				numeral: true
			},
			cleave_12_digits: {
				numeral: false,
				numericOnly: true,
				numeralDecimalScale: 0,
				numeralPositiveOnly: true,
				blocks: [12]
			},
			current_tab: 0,
			fields: [
				{
					key: "seller",
					label: this.$t('message.contracts.seller'),
					sortable: true
				},
				{
					key: "conditions",
					label: this.$t('message.contracts.conditions'),
					sortable: true
				},
				{
					key: "term",
					label: this.$t('message.contracts.term'),
					sortable: true
				},
				{
					key: "products",
					label: this.$t('message.contracts.product'),
					sortable: true
				},
				{
					key: 'actions',
					label: this.$t('message.contracts.actions'),
					tdClass: 'text-right'
				}

			],
			product_page: 1,
			product_fields: [
				{
					key: 'cgood_no',
					label: this.$t('message.contracts.product_number'),
					sortable: false
				},
				{
					key: 'attis_cg_good_name',
					label: this.$t('message.contracts.product_title'),
					sortable: true
				},
				{
					key: 'attis_cg_TNVED',
					label: this.$t('message.contracts.product_sku'),
					sortable: true
				},
				{
					key: 'attis_cg_quantity',
					label: this.$t('message.contracts.product_qty'),
					sortable: true
				},
				{
					key: 'attis_cg_price',
					label: this.$t('message.contracts.product_unit_price'),
					sortable: true
				},
				{
					key: 'remove',
					label: '',
					tdClass: 'text-right'
				}
			],
			form_error: false,
			companies_tmp: '',
			companys: [],
			product: {
				attis_cg_good_name: '',
				attis_cg_TNVED: '',
				attis_cg_quantity: '',
				attis_cg_measures: '',
				attis_cg_price: '',
			},
			ai_search: {
				ai_search_input: '',
				ai_search_results: '',
				ai_search_button_disabled: false,
			},
			attis_contract_goods: [],
			details: {
				seller: '',
				public: false,
				conditions: '',
				term: '',
			},
			tnveds: [],
			tnved_focused: false,
			placeholder_tnved: false,
			measures: [],
			delivery_terms: [],
			payment_types: [],
			companies: [],
			adbs: [],

			add_document: false,
			current_offer_chain: {},
			show_current_chain: false,

			language_focused: false,

			languages: [
				{ value: 'ru', display_text: this.$t('message.contracts.russian') },
				{ value: 'en', display_text: this.$t('message.contracts.english') },
				{ value: 'cn', display_text: this.$t('message.contracts.chinese') },
			],
			languagesPairs: [
				{ value: 'ru-en', display_text: this.$t('message.contracts.russian_english') },
				{ value: 'ru-cn', display_text: this.$t('message.contracts.russian_chinese') },
				{ value: 'en-cn', display_text: this.$t('message.contracts.english_chinese') },
			],

			owner_company: '',
			counterparty_name: '',

		}

	},
	methods: {
		/**
		 * determines if the row should be highlighted
		 */
		rowClassProduct(item, type) {

			if (!item || type !== 'row') return
			if (parseInt(item.cgood_no) === parseInt(this.looking_for_product_number)) return 'table-success'
		},
		/**
		 * looks for product in the grid by its guid
		 */
		lookForProductByNumber() {
			let index = this.attis_contract_goods.findIndex(good => parseInt(good.cgood_no) == parseInt(this.looking_for_product_number)) + 1
			if (!index)
				index = this.looking_for_product_number

			const page = Math.ceil(index / 3)
			this.product_page = page
		},
		/**
		 * finds absolute position of the element
		 */
		findPos(obj) {
			var curleft = 0;
			var curtop = 0;

			if (obj.offsetParent) {
				do {
					curleft += obj.offsetLeft;
					curtop += obj.offsetTop;
				} while (obj = obj.offsetParent);

				return { X: curleft, Y: curtop };
			}
		},
		show_history_json(data) {
			if (data.item.action_data.trim() != '')
				this.json_data = JSON.parse(data.item.action_data)
			this.$bvModal.show('show_history_details')
		},
		/**
		 * replaces data-name of the field with field ID for validation purposes
		 */
		field_name_replace(input) {
			let replaces = {
				'attis_contract_desc': 'contract_description',
				'attis_contract_subject': 'contract_subject',

			}
			return replaces[input]
		},
		/**
		 * Navigates user to the field with error
		 */
		go_to_error(error) {
			this.show_banks_error = false
			this.show_founder_error = false
			switch (error.Subsection) {
				case 'Contract':
					switch (error.Value) {
						case "attis_cg_contract_id":
							this.showAddProduct()
							setTimeout(() => {
								var element = document.querySelector('.add-product-block')
								console.log(element)
								var element_pos = this.findPos(element)
								console.log(element_pos)
								window.scrollTo(0, element_pos.Y - 50)
							}, 500)
							break;
						case "attis_contract_contragent":
							var element = document.querySelector('#' + error.Value)
							var element_pos = this.findPos(element)
							// element.parentNode.classList.add('error')
							element.focus()
							window.scrollTo(0, element_pos.Y - 50)
							break;
						case "attis_contract_subject":
							var element = document.querySelector('#' + this.field_name_replace(error.Value))
							var element_pos = this.findPos(element)
							// element.parentNode.classList.add('error')
							element.focus()
							window.scrollTo(0, element_pos.Y - 50)
							break;
						case "attis_contract_desc":
							var element = document.querySelector('#' + this.field_name_replace(error.Value))
							var element_pos = this.findPos(element)
							// element.parentNode.classList.add('error')
							element.focus()
							window.scrollTo(0, element_pos.Y - 50)
							break;
					}
					break;
				case 'CompanyAdress':
					//at the start we only have a company address validation
					//add more cases later, when we have more data validation

					//displays address modal
					this.show = 2;
					this.$bvModal.show('modal-addresses');
					//displays correct tab in the modal
					this.current_address_tab = 0;
					//highlights and focuses the field with error
					setTimeout(() => {
						let element = document.querySelector('#' + this.field_name_replace(error.Value) + '1')
						let element_pos = this.findPos(element)
						element.parentNode.classList.add('error')
						element.focus()
						let div = document.createElement('div')
						div.classList.add('error-description')
						div.innerHTML = error.Text
						element.parentNode.appendChild(div)
						document.querySelector('#modal-addresses').scrollTo(0, element_pos.Y - 50)
					}, 100)
					break;
				case 'Bank':
					this.show = 2;
					this.$bvModal.show('modal-account')
					this.show_banks_error = true
					this.banks_error_text = error
					break;
				case 'Company':
					this.show = 2;
					this.editCompany()
					setTimeout(() => {
						let element = document.querySelector('#' + this.field_name_replace(error.Value))
						let element_pos = this.findPos(element)
						element.parentNode.parentNode.classList.add('error')
						element.focus()
						let div = document.createElement('div')
						div.classList.add('error-description')
						div.innerHTML = error.Text
						element.parentNode.appendChild(div)
						window.scrollTo(0, element_pos.Y - 50)
					}, 100)
					break;
				case 'Founder':
					this.show = 2;
					this.$bvModal.show('modal-founders')
					this.show_founder_error = true
					this.founder_error_text = error
					break;
				case 'Person':
					this.show = 1;
					this.editPerson();
					setTimeout(() => {
						let element = document.querySelector('#' + this.field_name_replace(error.Value))
						let element_pos = this.findPos(element)
						element.parentNode.parentNode.classList.add('error')
						element.focus()
						let div = document.createElement('div')
						div.classList.add('error-description')
						div.innerHTML = error.Text
						element.parentNode.appendChild(div)
						window.scrollTo(0, element_pos.Y - 50)
					}, 100)
					break;
				default:
					this.current_tab = 6
					setTimeout(() => {
						this.$root.$emit('process_contract_error', error)
					}, 500)
					break;
			}
		},
		recalculate_offer_status(offers) {
			this.offer_is_accepted = false;
			offers.forEach(offer => {
				if (offer.status == 1)
					this.offer_is_accepted = true;
			})
		},
		check_undefined(field) {
			if (field && typeof (field.display_text) !== 'undefined') {
				return field.display_text
			}
			return '';
		},
		showOfferChain(item) {
			this.current_offer_chain = { ...item }
		},
		rowClass(item) {
			return item.status == 1 ? 'bg-success-light' : ''
		},
		accept_contract() {

		},
		sign_contract() {

		},
		ktg() {
			axios.get(window.base + '/contract/ktg?contract_id=' + this.$route.params.id).then(response => {
				//show noty
				if (response.data.status == 200) {
					new Noty({
						theme: 'light',
						type: 'success',
						text: this.$root.$t('message.message.ktg-ok'),
						timeout: 5000,
					}).show();
					this.files = response.data.files
				} else {
					new Noty({
						theme: 'light',
						type: 'error',
						text: this.$root.$t('message.message.ktg-nok') + ' (' + response.data.message + ')',
						timeout: 5000,
					}).show();
				}
			}).catch(e => {
				new Noty({
					theme: 'light',
					type: 'error',
					text: this.$root.$t('message.message.ktg-nok') + ' (' + e + ')',
					timeout: 5000,
				}).show();
			})
		},
		attachQualityDocFile(event) {
			if (typeof event.target.files[0] !== 'undefined')
				this.attis_contract_conditions.quality_doc = event.target.files[0]
			else
				this.attis_contract_conditions.quality_doc = ""
		},
		attachFileType(event, index) {
			this.files_att[index].type = event.value;
		},
		attachFileDate(event, index) {
			this.files_att[index].date = event;
		},
		attachFileReference(event, index) {
			this.files_att[index].reference_number = event;
		},
		attachFile(event, index) {
			if (typeof event.target.files[0] !== 'undefined')
				this.files_att[index].file = event.target.files[0]
		},
		removeFile(index) {
			this.files_att.splice(index, 1)
		},
		addAttachement() {
			console.log(this.files_att);
			this.files_att.push({ file: '', type: '', reference_number: '', date: '' });
			console.log(this.files_att);
		},
		deleteFile(file, index) {
			axios.get(window.base + '/Picture/DeleteFile/' + file.id).then(response => {
				this.files.splice(index, 1)
			})
		},
		cancelContract() {
			this.$bvModal.msgBoxConfirm(this.$t('message.contracts.close-contract'), {
				title: this.$t('message.confirm'),
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: this.$t('message.yes'),
				cancelTitle: this.$t('message.no'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value) {
					this.$router.push({ name: 'contracts-index' })
				}
			})
		},
		momentum(date) {
			return moment(date).format('DD.MM.Y')
		},
		momentum_time(date) {
			return moment(date).format('DD.MM.Y HH:mm')
		},
		sendAnswer(offer) {
			var fd = new FormData()
			fd.append('offer_id', offer.ID)
			for (var i in this.opened_offer_answer) {
				if (typeof this.opened_offer_answer[i] == 'object')
					fd.append(i, this.opened_offer_answer[i].value)
				else
					fd.append(i, this.opened_offer_answer[i])
			}
			// fd.append('answer', offer.answer_text)
			axios.post(window.base + '/contract/answerOffer', fd).then(response => {
				this.$bvModal.hide('modal-answer')
				this.$set(this.offers_list[this.offers_list.findIndex(i => i.ID == offers.ID)], 'can_show_chain', true)
			})
		},
		show_more_in_chain(index) {
			// console.log(1)
			if (this.uncollapse == index)
				this.uncollapse = -1
			else
				this.uncollapse = index
			// this.$set(this.opened_offer.chain[index], 'uncollapse', !this.opened_offer.chain[index].uncollapse)
		},
		showChain(offer) {
			this.opened_offer = offer
			axios.get(window.base + '/contract/chainOffer?offer_id=' + offer.ID).then(response => {
				console.log("chain response");
				console.log(response.data);
				this.$set(this.opened_offer, 'chain', response.data)
				this.$bvModal.show('modal-chain')
			})
		},
		searchContr() {
			this.search_loading = true
			var formData = new FormData();
			formData.append('org_residency', this.attis_contragents.country.value)
			formData.append('company_address', this.attis_contragents.city)
			formData.append('company_main_sphere', this.attis_contragents.sphere)
			formData.append('org_name', this.attis_contragents.name)
			formData.append('search_other', this.attis_contragents.search_other)
			axios.post(window.base + '/contract/searchContr?contract_id=' + this.$route.params.id, formData).then(response => {
				this.contragents_search_results = response.data
				this.search_loading = false
			})
		},
		saveSearch() {
			var formData = new FormData();
			formData.append('org_residency', this.attis_contragents.country.value)
			formData.append('company_address', this.attis_contragents.city)
			formData.append('company_main_sphere', this.attis_contragents.sphere)
			formData.append('org_name', this.attis_contragents.name)
			formData.append('search_other', this.attis_contragents.search_other)
			axios.post(window.base + '/contract/saveSearchContr?contact_id=' + this.$route.params.id, formData).then(response => {
				this.loadSavedSearches()
			})
		},
		loadSavedSearches() {
			axios.get(window.base + '/contract/loadSavedSearches?contract_id=' + this.$route.params.id).then(response => {
				this.saved_searches = response.data
			})
		},
		removeOffer(index) {
			axios.get(window.base + '/contract/deleteOffer?offer_id=' + this.offers_list[index].ID).
				then(response => {
					this.offers_list.splice(index, 1)
					if (response.data == 'ok') {
						new Noty({
							theme: 'light',
							type: 'success',
							text: this.$t('message.message.offer-deleted'),
							timeout: 5000,
						}).show();
					} else {
						new Noty({
							theme: 'light',
							type: 'error',
							text: this.$t('message.message.offer-not-deleted') + ' (' + response.data + ')',
							timeout: 5000,
						}).show();
					}
				})
		},
		add_offer() {
			this.$bvModal.show('modal-offer-new')
		},
		accept(offer) {
			axios.get(window.base + '/contract/acceptOffer?offer_id=' + offer.ID)
			this.$set(this.offers_list[this.offers_list.findIndex(i => i.ID == offer.ID)], 'status', 1)
			// this.offers_list[this.offers_list.findIndex(i=>i.ID==offer.ID)].status=1
			this.offer_is_accepted = true;
			this.$bvModal.hide('modal-offer')
		},
		decline(offer) {
			axios.get(window.base + '/contract/declineOffer?offer_id=' + offer.ID)
			this.$set(this.offers_list[this.offers_list.findIndex(i => i.ID == offer.ID)], 'status', -1)
			// this.offers_list[this.offers_list.findIndex(i=>i.ID==offer.ID)].status=-1
			this.$bvModal.hide('modal-offer')
		},
		submitAnswer(offer) {

		},
		answer(offer) {
			this.opened_offer_answer = { ...offer }
			this.$bvModal.hide('modal-offer')
			this.$bvModal.show('modal-answer')
		},
		showModalOffer(item, index, event) {
			console.log(item)
			this.opened_offer = item
			this.$set(this.offers_list[this.offers_list.findIndex(i => i.ID == item.ID)], 'can_show_chain', false)
			this.$bvModal.show('modal-offer')
			axios.get(window.base + '/contract/chainOffer?offer_id=' + item.ID).then(response => {
				if (response.data.length > 0)
					this.$set(this.offers_list[this.offers_list.findIndex(i => i.ID == item.ID)], 'can_show_chain', true)
			})
		},
		unAddDocument() {
			this.add_document = false

		},
		input_file(newFile, oldFile) {

			if (newFile && !oldFile) {
				// Add file
				this.$refs.upload_file.active = true
				if (newFile.size > 10000000 && newFile != oldFile) {
					new Noty({
						theme: 'light',
						type: 'error',
						text: this.$t('message.contracts.file_too_big'),
						timeout: 5000,
					}).show();
					this.$refs.upload_file.active = false
					return;
				}
			}

			if (newFile && oldFile) {
				// Update file

				// Start upload
				if (newFile.size > 10000000 && newFile != oldFile) {
					new Noty({
						theme: 'light',
						type: 'error',
						text: this.$t('message.contracts.file_too_big'),
						timeout: 5000,
					}).show();
					this.$refs.upload_file.active = false
					return;
				}
				// Upload progress
				if (newFile.progress !== oldFile.progress) {
				}

				// Upload error
				if (newFile.error !== oldFile.error) {
					var message = ''
					switch (newFile.error) {
						case 'extension':
							message = this.$t('message.contracts.file_wrong_type')
							break;

						default:
							message = newFile.error;
							break;
					}
					new Noty({
						theme: 'light',
						type: 'error',
						text: message,
						timeout: 5000,
					}).show();
				}

				// Uploaded successfully
				if (newFile.success !== oldFile.success) {
					this.$root.$emit('fileUploaded', { category: this.current_docs_category })
					this.add_document = false
				}
			}

			// Automatic upload
			if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
				if (!this.$refs.upload_file.active) {
					this.$refs.upload_file.active = true
				}
			}
		},
		addDocument() {
			// this.add_document = true
			this.$bvModal.show('modal-document-new')
		},
		loadDocuments(category) {
			this.current_docs_category = category
			this.$root.$emit('loadDocuments', { category: category })
		},
		addThousandsSeparator(n, thousandsSeparatorSymbol) {
			return new Intl.NumberFormat(this.locale).format(n)
		},
		validateField() {

		},
		amount() {
			var amount = 0
			if (typeof this.attis_contract_goods !== 'undefined')
				this.attis_contract_goods.forEach(item => {
					amount += item.attis_cg_price * item.attis_cg_quantity
				})
			return this.addThousandsSeparator(amount.toString(), ',')
		},
		getLibrary(type, query, qty) {
			query = query.toLowerCase()
			axios.get(window.base + '/library?type=' + type + '&query=' + query + '&qty=' + qty + '&lang=' + this.$i18n.locale)
				.then(response => {
					var var_name = type
					if (type[type.length - 1] == 's') {
						var_name = type + 'es'
					} else if (type[type.length - 1] == 'y') {
						var_name = type.substring(0, type.length - 1) + 'ies'
					} else {
						var_name = type + 's'
					}
					this.$data[var_name] = []
					response.data.forEach(item => {
						if (item.value !== '··········')
							this.$data[var_name].push(item)
					})
					// this.$data[var_name] = response.data
				})
		},
		fetchCurrencies() {
			this.getLibrary('currency', '', 100)
		},
		fetchTNVED(search, loading) {
			this.getLibrary('tnved', search, 100)
		},
		fetchMeasures(search, loading) {
			this.getLibrary('measure', search, 100)
		},
		fetchDeliveryTerms(search, loading) {
			this.getLibrary('delivery_term', search, 100)
		},
		fetchPaymentType(search, loading) {
			this.getLibrary('payment_type', search, 100)
		},
		fetchContragents(search, loading) {
			this.getLibrary('company', search, 100)
		},
		fetchAdbs(search, loading) {
			this.getLibrary('adb', search, 1000)
		},
		tnvedFocused() {
			this.tnved_focused = true
		},
		tnvedBlurred() {
			this.tnved_focused = false
			this.validateField('product.attis_cg_TNVED')
		},
		statusesFocused() {
			this.status_focused = true
		},
		statusesBlurred() {
			this.status_focused = false
			// this.validateField('company_status')
		},
		currenciesFocused() {
			this.currency_focused = true
		},
		currenciesBlurred() {
			this.currency_focused = false
			// this.validateField('company_status')
		},
		deliveryFocused() {
			this.delivery_focused = true
		},
		deliveryBlurred() {
			this.delivery_focused = false
			// this.validateField('company_status')
		},
		paymentFocused() {
			this.payment_focused = true
		},
		paymentBlurred() {
			this.payment_focused = false
			// this.validateField('company_status')
		},
		contragFocused() {
			this.contragent_focused = true
		},
		contragBlurred() {
			this.contragent_focused = false
			// this.validateField('company_status')
		},
		contrsearch_country_Focused() {
			this.contrsearch_country_focus = true
		},
		contrsearch_countryBlurred() {
			this.contrsearch_country_focus = false
		},

		stringifyProducts() {
			var result = [];
			this.attis_contract_goods.forEach((product, index) => {
				var line = ''

				line = 'product[' + index + '].attis_cg_good_name=' + product.attis_cg_good_name
				line += '&product[' + index + '].cgood_no=' + product.cgood_no
				line += '&product[' + index + '].cgood_guid=' + product.cgood_guid
				line += '&product[' + index + '].attis_cg_TNVED=' + product.attis_cg_TNVED.value
				line += '&product[' + index + '].attis_cg_quantity=' + product.attis_cg_quantity
				line += '&product[' + index + '].attis_cg_measures=' + product.attis_cg_measures.value
				line += '&product[' + index + '].attis_cg_price=' + product.attis_cg_price
				result.push(line)
			})
			return result.join('&')
		},
		checkContragent() {
			axios.get(window.base + '/admin/GetBillingServiceInfo?code=1')
				.then(response => {
					this.$bvModal.msgBoxConfirm(this.$t('message.contracts.check_contragent_price_alert') + ' ' + response.data.billing_service_price + ' ' + response.data.billing_service_cur, {
						title: this.$t('message.confirm'),
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'danger',
						okTitle: this.$t('message.yes'),
						cancelTitle: this.$t('message.no'),
						footerClass: 'p-2',
						hideHeaderClose: false,
						centered: true
					}).then(value => {
						if (value) {
							console.log('search value')
							console.log(value);

							//   console.log(this.$router)
							window.open(this.$router.options.base + '#/app/aml/' + (typeof this.attis_contracts.attis_contract_contragent.display_text === 'undefined' ? this.attis_contracts.attis_contract_contragent : this.attis_contracts.attis_contract_contragent.display_text), '_blank');
						}
					})
				})
		},
		submit() {
			this.$v.$touch()
			if (this.$v.attis_contracts.$invalid) {
				this.form_error = true
				setTimeout(() => {
					$('html,body').animate({ scrollTop: $('.has-danger').eq(0).offset().top - 50 }, 1000)
				}, 100)

			} else {
				// this.$bvModal.msgBoxConfirm(this.$t('message.contracts.contract_check_contragent'), {
				//   title: this.$t('message.confirm'),
				//   size: 'sm',
				//   buttonSize: 'sm',
				//   okVariant: 'danger',
				//   okTitle: this.$t('message.yes'),
				//   cancelTitle: this.$t('message.no'),
				//   footerClass: 'p-2',
				//   hideHeaderClose: false,
				//   centered: true
				// }).then(value => {
				//   	if(value){
				//   		window.open('/#/aml/'+(typeof this.attis_contracts.attis_contract_contragent.display_text === 'undefined'?this.attis_contracts.attis_contract_contragent:this.attis_contracts.attis_contract_contragent.display_text), '_blank');
				//   		// var formData = new FormData()
				//   		// if(typeof this.attis_contracts.attis_contract_contragent.value === 'undefined')
				//   		// 	formData.append('contragent', this.attis_contracts.attis_contract_contragent)
				//   		// else	
				//   		// 	formData.append('contragent', this.attis_contracts.attis_contract_contragent.value)
				//     // 	axios.get(window.base+'/document/aml?bin='+(typeof this.attis_contracts.attis_contract_contragent.value === 'undefined'?this.attis_contracts.attis_contract_contragent:this.attis_contracts.attis_contract_contragent.value)).
				//     // 	then(response=>{
				//     // 		window.open(response.data.url)
				//     		//save contract
				//     		this.form_error = false
				// 			this.loading = true
				// 			var tmp = this.attis_contracts
				// 			tmp.attis_contract_status = tmp.attis_contract_status.value
				// 			tmp.attis_contract_payment_type = tmp.attis_contract_payment_type.value
				// 			tmp.attis_contract_currency = tmp.attis_contract_currency.value
				// 			tmp.attis_contract_delivery_term = tmp.attis_contract_delivery_term.value
				// 			tmp.attis_contract_contragent = tmp.attis_contract_contragent.value
				// 			if(tmp.attis_contract_is_public)
				// 				tmp.attis_contract_is_public = true
				// 			else
				// 				tmp.attis_contract_is_public = false


				// 			var fd = new FormData()
				// 			var value = querystring.stringify(tmp)+'&'+this.stringifyProducts()+'&language='+this.$i18n.locale
				// 			value = value.split('&')
				// 			value.forEach(i=>{
				// 				i = i.split('=')
				// 				fd.append(decodeURI(i[0]), decodeURI(i[1]))
				// 			})
				// 			this.files_att.forEach((i, ndx)=>{
				// 				fd.append('Files['+ndx+']', i)
				// 			})
				// 			//conditions tab field
				// 			fd.append('overdue', this.attis_contract_conditions.overdue);
				// 			fd.append('packaging_transport_fees_included', this.attis_contract_conditions.packaging_transport_fees_included?1:0);
				// 			fd.append('goods_origin_country', this.attis_contract_conditions.goods_origin_country&&this.attis_contract_conditions.goods_origin_country.value?this.attis_contract_conditions.goods_origin_country.value:'');
				// 			fd.append('point_of_departure', this.attis_contract_conditions.point_of_departure);
				// 			fd.append('destination_point', this.attis_contract_conditions.destination_point);
				// 			fd.append('days_to_change_price', this.attis_contract_conditions.days_to_change_price);
				// 			fd.append('prepayment_percent', this.attis_contract_conditions.prepayment_percent);
				// 			fd.append('number_of_days_for_prepayment', this.attis_contract_conditions.number_of_days_for_prepayment);
				// 			fd.append('number_of_days_for_fullpayment', this.attis_contract_conditions.number_of_days_for_fullpayment);
				// 			fd.append('overdue_term', this.attis_contract_conditions.overdue_term);
				// 			fd.append('shipping_term', this.attis_contract_conditions.shipping_term);
				// 			fd.append('total_delivery_time', this.attis_contract_conditions.total_delivery_time);
				// 			fd.append('days_to_receive_goods', this.attis_contract_conditions.days_to_receive_goods);
				// 			fd.append('days_to_quality_receive_goods', this.attis_contract_conditions.days_to_quality_receive_goods);
				// 			fd.append('transfer_of_ownership', this.attis_contract_conditions.transfer_of_ownership?1:0);
				// 			fd.append('guaranty_term', this.attis_contract_conditions.guaranty_term);
				// 			fd.append('exceeding_guaranty_term', this.attis_contract_conditions.exceeding_guaranty_term?1:0);
				// 			fd.append('payment_overdue', this.attis_contract_conditions.payment_overdue);
				// 			fd.append('shipping_overdue', this.attis_contract_conditions.shipping_overdue);
				// 			fd.append('decline_due_to_overdue', this.attis_contract_conditions.decline_due_to_overdue);
				// 			fd.append('legal_country', this.attis_contract_conditions.legal_country&&this.attis_contract_conditions.legal_country.value?this.attis_contract_conditions.legal_country.value:'');
				// 			fd.append('arbitrage_country', this.attis_contract_conditions.arbitrage_country&&this.attis_contract_conditions.arbitrage_country.value?this.attis_contract_conditions.arbitrage_country.value:'');

				// 			fd.append('contract_language', this.attis_contract_conditions.contract_language&&this.attis_contract_conditions.contract_language.value?this.attis_contract_conditions.contract_language.value:'');
				// 			fd.append('contract_term', this.attis_contract_conditions.contract_term);
				// 			fd.append('notification_term', this.attis_contract_conditions.notification_term);
				// 			//eo conditions tab field
				// 			axios.post(window.base+'/Contract/Update?attis_contract_id='+this.$route.params.id, fd, {headers: { 'Content-Type': 'multipart/form-data' }})
				// 			.then(response=>{
				// 				if(response.data == 'ok' || response.data == '"ok"'){
				// 					new Noty({
				// 		        		theme: 'light',
				// 		        		type: 'success',
				// 					    text: this.$root.$t('message.message.contract-created'),
				// 					    timeout: 5000,
				// 					}).show();
				// 					this.$router.push({name: 'contracts-index'})
				// 					this.$root.$emit('reload-contracts')
				// 				}else{
				// 					new Noty({
				// 		        		theme: 'light',
				// 		        		type: 'error',
				// 					    text: this.$root.$t('message.message.contract-not-created')+' ('+response.data+')',
				// 					    timeout: 5000,
				// 					}).show();
				// 				}
				// 				// alert(response.data.statusMessage)
				// 				this.$router.push({name: 'contracts-index'})
				// 				this.$root.$emit('reload-contracts')
				// 				// this.load()
				// 				this.loading = false
				// 			}).catch(error=>{
				// 				new Noty({
				// 	        		theme: 'light',
				// 	        		type: 'error',
				// 				    text: this.$root.$t('message.message.contract-not-created')+' ('+error+')',
				// 				    timeout: 5000,
				// 				}).show();
				// 				this.loading = false

				// 			})
				// })
				//}else{
				this.form_error = false
				this.loading = true
				var tmp = this.attis_contracts
				tmp.attis_contract_status = tmp.attis_contract_status.value
				tmp.attis_contract_payment_type = tmp.attis_contract_payment_type.value
				tmp.attis_contract_currency = tmp.attis_contract_currency.value
				tmp.attis_contract_delivery_term = tmp.attis_contract_delivery_term.value
				tmp.attis_contract_contragent = tmp.attis_contract_contragent.value
				tmp.adb = this.is_send_to_adb ? (tmp.adb.value || "") : ""
				if (tmp.attis_contract_is_public)
					tmp.attis_contract_is_public = 1
				else
					tmp.attis_contract_is_public = 0

				var fd = new FormData()
				var value = querystring.stringify(tmp) + '&' + this.stringifyProducts() + '&language=' + this.$i18n.locale
				value = value.split('&')
				value.forEach(i => {
					i = i.split('=')
					fd.append(decodeURI(i[0]), decodeURI(i[1]))
				})
				this.files_att.forEach((i, ndx) => {
					fd.append('Files[' + ndx + ']', i.file)
					fd.append('FilesType[' + ndx + ']', i.type)
					fd.append('FilesNumber[' + ndx + ']', i.reference_number)
					fd.append('FilesDate[' + ndx + ']', i.date)
				})
				//conditions tab field
				fd.append('packaging_transport_fees_included', this.attis_contract_conditions.packaging_transport_fees_included ? 1 : 0);
				fd.append('goods_origin_country', this.attis_contract_conditions.goods_origin_country && this.attis_contract_conditions.goods_origin_country.value ? this.attis_contract_conditions.goods_origin_country.value : '');
				fd.append('point_of_departure', this.attis_contract_conditions.point_of_departure);
				fd.append('destination_point', this.attis_contract_conditions.destination_point);
				fd.append('prepayment_percent', this.attis_contract_conditions.prepayment_percent);
				fd.append('number_of_days_for_prepayment', this.attis_contract_conditions.number_of_days_for_prepayment);
				fd.append('number_of_days_for_fullpayment', this.attis_contract_conditions.number_of_days_for_fullpayment);
				fd.append('shipping_term', this.attis_contract_conditions.shipping_term);
				fd.append('days_to_receive_goods', this.attis_contract_conditions.days_to_receive_goods);
				fd.append('guaranty_term', this.attis_contract_conditions.guaranty_term);
				fd.append('payment_overdue', this.attis_contract_conditions.payment_overdue);
				fd.append('shipping_overdue', this.attis_contract_conditions.shipping_overdue);
				fd.append('decline_due_to_overdue', this.attis_contract_conditions.decline_due_to_overdue);
				fd.append('arbitrage_country', this.attis_contract_conditions.arbitrage_country && this.attis_contract_conditions.arbitrage_country.value ? this.attis_contract_conditions.arbitrage_country.value : '');
				fd.append('contract_language', this.attis_contract_conditions.contract_language && this.attis_contract_conditions.contract_language.value ? this.attis_contract_conditions.contract_language.value : '');
				fd.append('contract_term', this.attis_contract_conditions.contract_term);
				fd.append('quality_doc', this.attis_contract_conditions.quality_doc);
				fd.append('not_accept_fine', this.attis_contract_conditions.not_accept_fine)
				fd.append('opening_letter_deadline', this.attis_contract_conditions.opening_letter_deadline)
				fd.append('letter_payment_documents', this.attis_contract_conditions.letter_payment_documents)
				fd.append('docs_deadline_after_letter', this.attis_contract_conditions.docs_deadline_after_letter)
				fd.append('default_lang', this.attis_contract_conditions.default_lang && this.attis_contract_conditions.default_lang.value ? this.attis_contract_conditions.default_lang.value : '');
				fd.append('place_of_detention', this.attis_contract_conditions.place_of_detention)
				fd.append('seller_basis', this.attis_contract_conditions.seller_basis)
				fd.append('buyer_basis', this.attis_contract_conditions.buyer_basis)
				fd.append('buyer_full_name', this.attis_contract_conditions.buyer_full_name)
				fd.append('seller_full_name', this.attis_contract_conditions.seller_full_name)
				//eo conditions tab field
				axios.post(window.base + '/Contract/Update?attis_contract_id=' + this.$route.params.id, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
					.then(response => {
						if (response.data == 'ok' || response.data == '"ok"') {
							new Noty({
								theme: 'light',
								type: 'success',
								text: this.$root.$t('message.message.contract-created'),
								timeout: 5000,
							}).show();
							this.$router.push({ name: 'contracts-index' })
							this.$root.$emit('reload-contracts')
						} else {
							new Noty({
								theme: 'light',
								type: 'error',
								text: this.$root.$t('message.message.contract-not-created') + ' (' + response.data + ')',
								timeout: 5000,
							}).show();
						}
						this.$router.push({ name: 'contracts-index' })
						this.$root.$emit('reload-contracts')
						this.loading = false
					}).catch(error => {
						new Noty({
							theme: 'light',
							type: 'error',
							text: this.$root.$t('message.message.contract-not-created') + ' (' + error + ')',
							timeout: 5000,
						}).show();
						this.loading = false
					})
				//}
				//})

			}
		},
		removeProduct(index) {
			this.attis_contract_goods.splice(index, 1)
		},
		editProduct(index) {
			this.product = this.attis_contract_goods[index]
			this.currently_editing = index
			this.edit_product = true
		},
		saveProduct() {
			this.$v.$touch('product')
			if (this.$v.product.$invalid) {
				this.product_error = true
				setTimeout(() => {
					$('html,body').animate({ scrollTop: $('.has-danger').eq(0).offset().top - 50 }, 1000)
				}, 100)

			} else {
				this.product_error = false
				this.hideEditProduct()
			}
		},
		addProduct() {
			// this.hideAddProduct()
			this.$v.$touch('product')
			if (this.$v.product.$invalid) {
				this.product_error = true
				setTimeout(() => {
					$('html,body').animate({ scrollTop: $('.has-danger').eq(0).offset().top - 50 }, 1000)
				}, 100)

			} else {
				this.product_error = false
				this.hideAddProduct()
				this.attis_contract_goods.push({
					cgood_no: this.attis_contract_goods.length + 1,
					cgood_guid: '',
					attis_cg_good_name: this.product.attis_cg_good_name,
					attis_cg_TNVED: this.product.attis_cg_TNVED,
					attis_cg_quantity: this.product.attis_cg_quantity,
					attis_cg_measures: this.product.attis_cg_measures,
					attis_cg_price: this.product.attis_cg_price,
				})
				this.product = {
					attis_cg_good_name: '',
					attis_cg_TNVED: '',
					attis_cg_quantity: '',
					attis_cg_measures: '',
					attis_cg_price: '',
				}

			}

		},
		showAddProduct() {
			// If some product was edited we must remove reference.
			this.product = {
				attis_cg_good_name: '',
				attis_cg_TNVED: '',
				attis_cg_quantity: '',
				attis_cg_measures: '',
				attis_cg_price: '',
			},
				this.add_product = true;
		},
		hideEditProduct() {
			this.edit_product = false
		},
		hideAddProduct() {
			this.add_product = false;
		},
		findLibValueProduct(lib, value, field, index) {
			if (typeof lib == 'string') {
				axios.get(window.base + '/library?type=' + lib + '&query=&qty=1000' + '&lang=' + this.$i18n.locale)
					.then(response => {
						response.data.forEach(item => {
							if (item.value == value) {
								this.$set(this.attis_contract_goods[index], field, item)
							}
						})
					})
			}
		},
		findLibValue(lib, value, field, callback = null) {
			if (typeof lib == 'string') {
				axios.get(window.base + '/library?type=' + lib + '&query=&qty=1000' + '&lang=' + this.$i18n.locale)
					.then(response => {
						response.data.forEach(item => {
							if (item.value.trim().toLowerCase() == value.trim().toLowerCase()) {
								this.$set(this.attis_contracts, field, item)
							}
						})
					}).finally(() => {
						callback && callback()
					})
			} else {
				lib.forEach(item => {
					if (item.value == value) {
						this.$set(this.attis_contracts, field, item)
					}
				})
				callback && callback()
			}
		},
		closeDocument() {
			if (this.$router.currentRoute?.fullPath?.includes('app/contracts')) {
				this.$router.push({ name: 'contracts-index' })
			} else {
				this.$router.go(-1)
			}
			// this.$router.go(-1)
			// if(this.attis_contracts.is_signed_by_owner && this.attis_contracts.is_signed_by_counterparty)
			// 	this.$router.push({name: 'deals-index'})
			// else
			// 	this.$router.push({name: 'contracts-index'})
		},
		load() {
			axios.get(window.base + '/document/getFirm').then(response => {
				this.owner_company = response.data.org_name
			})

			axios.get(window.base + '/Contract/GetContract?attis_contract_id=' + this.$route.params.id)
				.then(response => {

					this.attis_contracts.attis_contract_id = response.data.attis_contract_id
					this.attis_contracts.attis_contract_owner = response.data.attis_contract_owner
					this.findLibValue(this.statuses, response.data.attis_contract_status, 'attis_contract_status')
					this.attis_contracts.attis_contract_type = response.data.attis_contract_type
					this.attis_contracts.attis_contract_case = response.data.attis_contract_case
					this.attis_contracts.attis_contract_subject = response.data.attis_contract_subject
					this.attis_contracts.attis_contract_desc = response.data.attis_contract_desc
					this.findLibValue('currency', response.data.attis_contract_currency, 'attis_contract_currency')
					this.findLibValue('delivery_term', response.data.attis_contract_delivery_term, 'attis_contract_delivery_term')
					this.attis_contracts.attis_contract_date = response.data.attis_contract_date
					this.findLibValue('payment_type', response.data.attis_contract_payment_type, 'attis_contract_payment_type')
					this.findLibValue('company', response.data.attis_contract_contragent, 'attis_contract_contragent')
					// this.findLibValue('adb', response.data.adb, 'adb', ()=>{
					// 	this.is_send_to_adb = Boolean(this.attis_contracts.adb.value);
					// 	this.is_sent_to_adb = Boolean(response.data.adb);
					// })

					setTimeout(() => {
						axios.get(window.base + '/document/getFirmbyBin?bin=' + this.attis_contracts.attis_contract_contragent.value).then(response => {
							this.counterparty_name = response.data.persons.given_name + ' ' + response.data.persons.middle_name + ' ' + response.data.persons.last_name
						})
					}, 1000)

					this.attis_contracts.attis_contract_deadline = response.data.attis_contract_deadline
					this.attis_contracts.attis_contract_create_date = response.data.attis_contract_create_date
					this.attis_contracts.attis_contract_is_public = Boolean(response.data.attis_contract_is_public)

					//conditions tab part
					this.attis_contract_conditions.packaging_transport_fees_included = response.data.packaging_transport_fees_included
					axios.get(window.base + '/library/country?code=' + response.data.goods_origin_country + '&lang=' + this.$i18n.locale).then(cntr => {
						this.attis_contract_conditions.goods_origin_country = cntr.data[0]
					})
					this.attis_contract_conditions.point_of_departure = response.data.point_of_departure
					this.attis_contract_conditions.destination_point = response.data.destination_point
					this.attis_contract_conditions.prepayment_percent = response.data.prepayment_percent
					this.attis_contract_conditions.number_of_days_for_prepayment = response.data.number_of_days_for_prepayment
					this.attis_contract_conditions.number_of_days_for_fullpayment = response.data.number_of_days_for_fullpayment
					this.attis_contract_conditions.shipping_term = response.data.shipping_term
					this.attis_contract_conditions.days_to_receive_goods = response.data.days_to_receive_goods
					this.attis_contract_conditions.guaranty_term = response.data.guaranty_term
					this.attis_contract_conditions.payment_overdue = response.data.payment_overdue
					this.attis_contract_conditions.shipping_overdue = response.data.shipping_overdue
					this.attis_contract_conditions.decline_due_to_overdue = response.data.decline_due_to_overdue
					axios.get(window.base + '/library/country?code=' + response.data.arbitrage_country + '&lang=' + this.$i18n.locale).then(cntr => {
						this.attis_contract_conditions.arbitrage_country = cntr.data[0]
					})
					var ind = this.languagesPairs.findIndex(itm => itm.value == response.data.contract_language);
					if (ind > -1)
						this.attis_contract_conditions.contract_language = this.languagesPairs[ind]
					else
						this.attis_contract_conditions.contract_language = { value: '' }
					this.attis_contract_conditions.contract_term = response.data.contract_term
					//eo conditions tab part

					//signatures part
					this.attis_contracts.is_signed_by_owner = response.data.is_signed_by_owner
					this.attis_contracts.when_is_signed_by_owner = response.data.when_is_signed_by_owner
					this.attis_contracts.how_is_signed_by_owner = response.data.how_is_signed_by_owner
					this.attis_contracts.name_of_signature_owner = response.data.name_of_signature_owner

					this.attis_contracts.is_signed_by_counterparty = response.data.is_signed_by_counterparty
					this.attis_contracts.when_is_signed_by_counterparty = response.data.when_is_signed_by_counterparty
					this.attis_contracts.how_is_signed_by_counterparty = response.data.how_is_signed_by_counterparty
					this.attis_contracts.name_of_signature_counterparty = response.data.name_of_signature_counterparty

					this.attis_contract_conditions.quality_doc = response.data.quality_doc
					this.attis_contract_conditions.not_accept_fine = response.data.not_accept_fine
					this.attis_contract_conditions.opening_letter_deadline = response.data.opening_letter_deadline
					this.attis_contract_conditions.letter_payment_documents = response.data.letter_payment_documents
					this.attis_contract_conditions.docs_deadline_after_letter = response.data.docs_deadline_after_letter
					this.attis_contract_conditions.default_lang = response.data.default_lang
					var ind = this.languages.findIndex(itm => itm.value == response.data.default_lang);
					if (ind > -1)
						this.attis_contract_conditions.default_lang = this.languages[ind]
					else
						this.attis_contract_conditions.default_lang = { value: '' }
					this.attis_contract_conditions.place_of_detention = response.data.place_of_detention
					this.attis_contract_conditions.seller_basis = response.data.seller_basis
					this.attis_contract_conditions.buyer_basis = response.data.buyer_basis
					this.attis_contract_conditions.seller_full_name = response.data.seller_full_name
					this.attis_contract_conditions.buyer_full_name = response.data.buyer_full_name


					// this.attis_contracts.is_signed_by_owner = true
					// this.attis_contracts.when_is_signed_by_owner = "2021-09-30 11:45:00"
					// this.attis_contracts.how_is_signed_by_owner = "code"

					// this.attis_contracts.is_signed_by_counterparty = true
					// this.attis_contracts.when_is_signed_by_counterparty = "2021-09-30 11:55:00"
					// this.attis_contracts.how_is_signed_by_counterparty = "signature"
					//eo signature part

					this.attis_contract_goods = response.data.product
					this.processProducts()
					this.files = response.data.files
				})
			this.loadOffers()
			this.loadHistory()
		},
		loadOffers() {
			axios.get(window.base + '/contract/getOffer?attis_contract_id=' + this.$route.params.id).
				then(response => {
					if (response.data.offers != null) {
						if (_.isArray(response.data.offers) && !_.isEmpty(response.data.offers)) {
							if (response.data.offers.length > 0 && !this.is_owner) {
								this.can_add_offer = false;
							}

							this.offers_list = response.data.offers
							this.recalculate_offer_status(this.offers_list);
						}
						else {
							axios.get(window.base + '/contract/CheckOfferAccepted?attis_contract_id=' + this.$route.params.id).
								then(res => {
									if (res.data == 1)
										this.offer_is_accepted = true;
								})
						}
					}
					else {
						this.offers_list = []
						axios.get(window.base + '/contract/CheckOfferAccepted?attis_contract_id=' + this.$route.params.id).
							then(res => {
								if (res.data == 1)
									this.offer_is_accepted = true;
							})
					}


					if (this.$route.name == 'offer-single') {
						this.current_tab = 2
						var index = this.offers_list.findIndex(i => i.ID == parseInt(this.$route.params.oid))
						var item = this.offers_list[index]
						setTimeout(() => {
							this.showModalOffer(item, index, false)
						}, 140)
					}
					if (this.$route.name == 'courier-single') {
						this.current_tab = 3
					}
					if (this.$route.name == 'broker-single') {
						this.current_tab = 4
					}
				})
		},
		loadHistory() {
			axios.get(window.base + '/contract/getHistory?contract_id=' + this.$route.params.id).then(response => {
				if (response.data != null) {
					this.history_list = response.data
					this.history_list.forEach((item, i) => {
						var messages = this.history_types.filter(msg => {
							return msg.section.toLowerCase() == item.action_section.toLowerCase() &&
								msg.value == item.action_type
						})
						if (messages[0].display_text !== 'undefined')
							item.action_type = messages[0].display_text;
						item.action_date = item.action_date;
					})
				}
				else
					this.history_list = []


			})
		},
		findTNVED(code, index) {
			axios.get(window.base + '/library/tnved?code=' + code + '&lang=' + this.$i18n.locale).then(response => {
				if (typeof response.data[0] !== 'undefined')
					this.$set(this.attis_contract_goods[index], 'attis_cg_TNVED', response.data[0])
			})
		},
		processProducts() {
			if (typeof this.attis_contract_goods !== 'undefined')
				this.attis_contract_goods.forEach((item, index) => {
					this.findTNVED(item.attis_cg_TNVED, index)
					if (item.attis_cg_measures)
						this.findLibValueProduct('measure', item.attis_cg_measures, 'attis_cg_measures', index)
				})
		},
		fetchCountries(search, loading) {
			this.getLibrary('country', search, 100)
		},
		AISearch() {
			if (this.ai_search.ai_search_input.length < 3) return
			this.ai_search.ai_search_button_disabled = true
			axios.get(window.base + '/library/bardapi?query=' + encodeURIComponent(this.ai_search.ai_search_input)).then(response => {
				if (this.ai_search.ai_search_button_disabled === false) {
					return
				}
				this.ai_search.ai_search_results = response.data
			}).finally(() => {
				this.ai_search.ai_search_button_disabled = false
			})
		},
		AISearchCancel() {
			this.ai_search.ai_search_button_disabled = false
			this.ai_search.ai_search_input = ""
			this.ai_search.ai_search_results = ""
		},
		showAISearchModal() {
			if (this.product.attis_cg_good_name)
				this.ai_search.ai_search_input = `What is HS code for ${this.product.attis_cg_good_name}?`;
			this.$bvModal.show('ai-search-modal');
		},
		cancel(type) {
			this.$bvModal.msgBoxConfirm(this.$t('message.contracts.document_cancel_message'), {
				title: this.$t('message.confirm'),
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: this.$t('message.yes'),
				cancelTitle: this.$t('message.no'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
				.then(value => {
					if (value)
						this.$root.$emit('bv::hide::modal', 'modal-document-' + type, '#btnShow')
				})
				.catch(err => {
					// An error occurred
				})
		},
		/**
		 * get contract XML and sends it to backend along with token from e-mail to sign data
		 * after signing it gets the signature code and sends it back to the backend
		 * to store signature in contract
		 */
		sign_with_code_phase2() {
			if (typeof this.attis_contracts.attis_contract_contragent.value !== 'undefined' && this.attis_contracts.attis_contract_contragent.value != '') {
				if (this.sign_with_code_code != '') {
					this.loading_sign = true
					axios.get(window.base + '/Contract/getcontractxml?attis_contract_id=' + this.attis_contracts.attis_contract_id).then(response => {
						var fd = new FormData
						var xml = response.data.replace('<?xml version="1.0" encoding="utf-16"?>', '')
						fd.append('token', this.sign_with_code_code)
						fd.append('data', window.Base64.encode(xml))
						axios.post(window.base + '/account/SignData', fd).then(response => {
							if ('token invalid' === response.data) {
								this.show_code_sign_type = false
								new Noty({
									theme: 'light',
									type: 'error',
									text: this.$t('message.message.contract_not_signed') + ' (' + response.data + ')',
									timeout: 5000,
								}).show();
							} else {
								var fd = new FormData;
								fd.append('contract_id', this.attis_contracts.attis_contract_id)
								fd.append('signature', response.data)
								fd.append('type', 'code')
								axios.post(window.base + '/contract/AddSignature', fd).then(() => {
									this.loading = false
									this.show_code_sign_type = false
									this.loading_sign = false
									this.sign_with_code_code = ''
									this.load() //refresh status of the contract
									new Noty({
										theme: 'light',
										type: 'success',
										text: this.$t('message.message.contract_signed'),
										timeout: 5000,
									}).show();
									this.$bvModal.hide('modal-select-ecp-type')
								}).catch(e => {
									this.loading = false
									this.loading_sign = false
									new Noty({
										theme: 'light',
										type: 'error',
										text: this.$t('message.message.contract_not_signed') + ' (' + e + ')',
										timeout: 5000,
									}).show();
									this.$bvModal.hide('modal-select-ecp-type')
								})
							}
						}).catch(e => {
							this.loading = false
							this.loading_sign = false
							new Noty({
								theme: 'light',
								type: 'error',
								text: this.$t('message.message.contract_not_signed') + ' (' + e + ')',
								timeout: 5000,
							}).show();
							this.$bvModal.hide('modal-select-ecp-type')
						})
					})
				}
			}
			else {
				this.loading = false
				this.loading_sign = false
				new Noty({
					theme: 'light',
					type: 'error',
					text: this.$t('message.message.signature_no_contragent') + ' (' + e + ')',
					timeout: 5000,
				}).show();
				this.$bvModal.hide('modal-select-ecp-type')
			}

		},
		/**
		 * Sends request to backend to send a code to sign a contract without ECP
		 */
		sign_with_code() {
			axios.get(window.base + '/account/GenerateToken?doc_id=' + this.attis_contracts.attis_contract_id).then(response => {
				console.log(response.data)
				this.show_code_sign_type = true
			})
		},
		/**
		 * Displays a dialog to select which method of electronic signature fits user the best.
		 */
		submit_and_sign_dialog() {
			this.$bvModal.show('modal-select-ecp-type')
		},
		/**
		 * Initializes electorinc signature for the contract. 
		 * Gets XML from backend.
		 * Signs with NCA Layer.
		 * Sends signature back to backend to store for future comparison.
		 */
		submit_and_sign() {
			if (typeof this.attis_contracts.attis_contract_contragent.value !== 'undefined' && this.attis_contracts.attis_contract_contragent.value != '') {
				this.loading = true
				axios.get(window.base + '/Contract/getcontractxml?attis_contract_id=' + this.attis_contracts.attis_contract_id).then(response => {
					this.xml = response.data.replace('<?xml version="1.0" encoding="utf-16"?>', '')
					window.webSocket = new WebSocket('wss://127.0.0.1:13579/');
					window.callback = null;

					window.webSocket.onopen = (event) => {
						console.log("onopen");
						// window.getKeyInfo('PKCS12', "getKeyInfoBack");
						window.signXml("PKCS12", "SIGNATURE", this.xml, () => {
						});
					};

					window.webSocket.onclose = function (event) {
						console.log("onclose");
						if (event.wasClean) {
						} else {
							openDialog();
						}
					};

					window.webSocket.onmessage = (event) => {
						console.log("onmessage");
						var result = JSON.parse(event.data);
						// window.signXml("PKCS12", "SIGNATURE", this.xml, ()=>{
						// });
						// return true;
						if (result != null) {
							var rw = {
								code: result['code'],
								message: result['message'],
								responseObject: result['responseObject'],
								getResult: function () {
									return this.result;
								},
								getMessage: function () {
									return this.message;
								},
								getResponseObject: function () {
									return this.responseObject;
								},
								getCode: function () {
									return this.code;
								}
							};
							if (rw.code == '200') {
								console.log(result)
								var oParser = new DOMParser();
								var oDOM = oParser.parseFromString(rw.getResponseObject(), "application/xml");
								var certificate = oDOM.getElementsByTagName('ds:X509Certificate')[0].innerHTML
								var value = oDOM.getElementsByTagName('ds:SignatureValue')[0].innerHTML
								axios.get(window.base + '/account/loadSignatureDetails').then(response => {
									let cert = response.data.cert.replace(/(?:\r\n|\r|\n)/g, "");
									let name = response.data.cert_name;
									console.log(cert);
									console.log(certificate);
									if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, '')) {
										var fd = new FormData;
										fd.append('contract_id', this.attis_contracts.attis_contract_id)
										fd.append('signature', value)
										fd.append('signature_name', name)
										fd.append('type', 'signature')
										axios.post(window.base + '/contract/AddSignature', fd).then(() => {
											this.loading = false
											this.load() //refresh status of the contract
											new Noty({
												theme: 'light',
												type: 'success',
												text: this.$t('message.message.contract_signed'),
												timeout: 5000,
											}).show();
											this.$bvModal.hide('modal-select-ecp-type')
											this.$router.push({ name: 'contracts-single-signed', params: { id: this.$route.params.id } })
										}).catch(e => {
											console.log(e);
											this.loading = false
											new Noty({
												theme: 'light',
												type: 'error',
												text: this.$t('message.message.contract_not_signed') + ' (' + e + ')',
												timeout: 5000,
											}).show();
											this.$bvModal.hide('modal-select-ecp-type')
										})
									} else {
										console.log('cert not equal');
										this.loading = false
										new Noty({
											theme: 'light',
											type: 'error',
											text: this.$t('message.message.contract_not_signed_cert_invalid'),
											timeout: 5000,
										}).show();
									}
								})

								window.webSocket.removeEventListener('message', {})
								window.webSocket.close();
							}
						}
					};
				})
			}
			else {
				this.loading = false
				this.loading_sign = false
				new Noty({
					theme: 'light',
					type: 'error',
					text: this.$t('message.message.signature_no_contragent') + ' (' + e + ')',
					timeout: 5000,
				}).show();
				this.$bvModal.hide('modal-select-ecp-type')
			}

		},
		importGoodsExcel(event, index) {
			if (typeof event.target.files[0] !== 'undefined') {
				var fd = new FormData
				this.files_loading = true
				fd.append('Files[0]', event.target.files[0])
				axios.post(window.base + '/document/import_excel_goods?type=contract', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
					this.files_loading = false;
					if (response.data !== 'error') {
						response.data.forEach(good => {
							var tmp_good = {}
							//tmp_good.good_guid = good.cgood_guid
							tmp_good = good;
							tmp_good.cgood_guid = this.attis_contract_goods.length + 1,


								this.attis_contract_goods.push(tmp_good)


						})
						this.processProducts();
					}
					//this.hideAddProduct();



				})

			}
		},
		saveAdb() {
			axios.post(`${window.base}/contract/saveadb`, {
				adb: {
					contract_id: this.attis_contracts.attis_contract_id,
					adb: this.attis_contracts.adb.value,
				}
			}).then(res => {
				this.is_sent_to_adb = Boolean(this.attis_contracts.adb.value);
				new Noty({
					theme: 'light',
					type: 'success',
					text: this.$t('message.message.success'),
					timeout: 5000,
				}).show();
			})
		},
	},
	mounted() {
		if (!this.$store.state.auth)
			this.$router.push({ name: 'sign-in' })
		setTimeout(() => {
			var el = this
			$('#attis_contract_conditions_point_of_departure').focus(function () {
				el.cus_adr = new ymaps.SuggestView('attis_contract_conditions_point_of_departure')
				el.cus_adr.events.add(['select'], (event) => {
					// console.log(event)
					el.attis_contract_conditions.point_of_departure = event.get('item').value
				})
			})
			$('#attis_contract_conditions_destination_point').focus(function () {
				el.com_adr = new ymaps.SuggestView('attis_contract_conditions_destination_point')
				el.cus_adr.events.add(['select'], (event) => {
					// console.log(event)
					el.attis_contract_conditions.point_of_departure = event.get('item').value
				})
				// el.com_adr.events.add(['select'], (event)=>{
				// 	el.attis_contract_conditions.destination_point = event.get('item').value
				// 	ymaps.geocode(el.attis_contract_conditions.destination_point).then(function (res) {
				// 		var obj = res.geoObjects.get(0)
				// 		el.attis_contract_conditions.destination_point = obj.getCountry()
				// 	})
				// })
			})
		}, 1000)
		this.$root.$on('process-document-error-to-contract', (error_data) => {
			this.current_tab = 0;
			setTimeout(() => {
				this.go_to_error(error_data);
			}, 500)

		})
		this.$root.$on('set.seller.contragent', (data) => {
			this.$bvModal.hide('modal-add-new_user')
			this.attis_contracts.attis_contract_contragent = { value: data.company.number, display_text: data.company.name }
		})
		this.$root.$on('set.buyer.contragent', (data) => {
			this.$bvModal.hide('modal-add-new_user')
			this.attis_contracts.attis_contract_contragent = { value: data.company.number, display_text: data.company.name }
		})
		if (!this.$store.state.auth) {
			this.$router.push({ name: 'sign-in' })
		} else {
			this.fetchCurrencies()
			this.fetchTNVED('')
			this.fetchMeasures('')
			this.fetchDeliveryTerms('')
			this.fetchPaymentType('')
			this.fetchContragents('')
			this.fetchCountries('')
			this.fetchAdbs('')
			this.loadSavedSearches('')

			setTimeout(() => {
				this.load()
			}, 500)

		}
		this.$root.$on('reloadOffers', () => {
			this.load()
			//this.loadOffers()
		})
		this.$root.$on('loadDocuments', (data) => {
			this.current_docs_category = data.category
		})
		console.log(this.$route.name)

		if (this.$route.name == 'contracts-single-offers-tab')
			this.current_tab = 2
		if (this.$route.name == 'contracts-single-couriers-tab')
			this.current_tab = 3
		if (this.$route.name == 'contracts-single-brokers-tab')
			this.current_tab = 4
		setTimeout(() => {
			if (this.$route.name == 'contracts-single-documents-tab') {
				this.current_tab = 6
			}
		}, 1000)
	},
	computed: {
		//checks if we''ve opened a contract from deals
		is_deal() {
			if (this.attis_contracts.is_signed_by_owner || this.attis_contracts.is_signed_by_counterparty)
				return true
			if (this.$route.name == 'deals-single')
				return true
			return false
		},
		/**
		 * In case contract is signed by one of the counterparties, make fields read-only, to prevent changes of the contract.
		 */
		is_field_readonly() {
			if (window.dev_mode === true)
				return false
			if (this.$route.name == 'deals-single')
				return true
			if (this.attis_contracts.is_signed_by_owner || this.attis_contracts.is_signed_by_counterparty)
				return true

			if (this.$store.state.user.id != this.attis_contracts.attis_contract_owner)
				return true
			return false
		},
		/**
		 * In case that current user is counterparty of the contract, and 
		 * contract is not signed with counterparty, then allow to show button
		 * to sign contract by counterparty
		 */
		is_counterparty_to_sign() {
			if (this.attis_contracts.is_signed_by_owner && !this.attis_contracts.is_signed_by_counterparty && this.$store.state.user.id != this.attis_contracts.attis_contract_owner)
				return true

			return false
		},
		/**
		 * 
		 * Checks if the contract has both contragents (contract owner is set apriori, checking 
		 * if the buyer/seller is defined). In case both of them are set – the contract can be 
		 * signed with electronic signature
		 */
		can_sign_contract() {
			if (typeof this.attis_contracts.attis_contract_contragent !== 'undefined' && typeof this.attis_contracts.attis_contract_contragent.value !== 'undefined' && this.attis_contracts.attis_contract_contragent.value !== '')
				return false
			return true
		},
		is_owner() {
			// if(window.dev_mode===true)
			// 	return true
			return this.attis_contracts.attis_contract_owner == this.user_id
		},
		filtered_offers_list() {
			return this.offers_list.filter(i => {
				if (this.show_declined == true) {
					if (i.status === -1)
						return i
				} else {
					if (i.status !== -1)
						return i
				}

			})
		},
		can_send_offer() {
			if (typeof this.attis_contracts.attis_contract_status === 'object') {
				if (this.attis_contracts.attis_contract_status.value == 1 && this.is_owner)
					return true
				return false
			} else {
				if (this.attis_contracts.attis_contract_status == 1 && this.is_owner)
					return true
				return false
			}
		},
		can_sign() {
			if (typeof this.attis_contracts.attis_contract_status === 'object') {
				if (this.attis_contracts.attis_contract_status.value == 1 && this.user_id == this.attis_contracts.attis_contract_owner)
					return true
				return false
			} else {
				if (this.attis_contracts.attis_contract_status == 1 && this.user_id == this.attis_contracts.attis_contract_owner)
					return true
				return false
			}
		},
		can_accept() {
			if (typeof this.attis_contracts.attis_contract_status === 'object') {
				if (this.attis_contracts.attis_contract_status.value == 1 && this.user_id != this.attis_contracts.attis_contract_owner)
					return true
				return false
			} else {
				if (this.attis_contracts.attis_contract_status == 1 && this.user_id != this.attis_contracts.attis_contract_owner)
					return true
				return false
			}
		},
		the_id() {
			return this.$route.params.id
		},
		user_id() {
			return this.$store.state.user.id
		},
		user_role() {
			if (typeof this.$store.state.user !== 'undefined')
				return this.$store.state.user.Roles
			else
				return ['Owner']
		},
		upload_endpoint() {
			return '/Contract/UploadDoc/?contract=' + this.$route.params.id + '&category=' + this.current_docs_category
		},
		locale() {
			var locale = this.$i18n.locale
			var _this = this
			switch (locale) {
				case 'cn': locale = 'zh-CN'; break;
				case 'en': locale = 'en-US'; break;
			}
			return locale
		}
	},
	watch: {
		companies_tmp: _.debounce(function (query) { this.getLibrary('company', query) }, 500),
		current_tab() {
			if (this.current_tab == 2) { //if current_tab is offers
				this.$router.push({ name: 'contracts-single-offers-tab', params: { id: this.$route.params.id } })
			}
			if (this.current_tab == 3) { //if current_tab is offers
				this.$router.push({ name: 'contracts-single-couriers-tab', params: { id: this.$route.params.id } })
			}
			if (this.current_tab == 4) { //if current_tab is offers
				this.$router.push({ name: 'contracts-single-brokers-tab', params: { id: this.$route.params.id } })
			}

		},
	},
	validations: {
		attis_contracts: {
			attis_contract_status: {
				required
			},
			attis_contract_type: {
				required
			},
			attis_contract_case: {
				required
			},
			attis_contract_subject: {
				required
			}
		},
		product: {
			attis_cg_good_name: {
				required,
			},
			attis_cg_TNVED: {
				required
			},
		},
	}
}
</script>
<style lang="scss">
.has-plus-infront:before {
	content: '+';
	display: inline-block;
	margin: 0 10px;
}

.rounded-bottom {
	border-bottom-left-radius: 6px !important;
	border-bottom-right-radius: 6px !important;
}

.rounded-top {
	border-top-left-radius: 6px !important;
	border-top-right-radius: 6px !important;
}

.upload {
	position: relative;
	// margin: 10px 54px 26px 54px;
	border: 1px dashed #999999;
	height: 309px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	color: #999;
	transition: all .5s;
}

.bg-success-light {
	background-color: rgba(76, 175, 80, .16) !important;
}

body {
	background-color: #f9fafb;
}

@media (min-width: 992px) {
	.inbox-wrapper .email-aside .aside-content {
		padding-right: 10px;
	}
}

.inbox-wrapper .email-aside .aside-content .aside-header {
	padding: 0 0 5px;
	position: relative;
}

.inbox-wrapper .email-aside .aside-content .aside-header .title {
	display: block;
	margin: 3px 0 0;
	font-size: 1.1rem;
	line-height: 27px;
	color: #686868;
}

.inbox-wrapper .email-aside .aside-content .aside-header .navbar-toggle {
	background: 0 0;
	display: none;
	outline: 0;
	border: 0;
	padding: 0 11px 0 0;
	text-align: right;
	margin: 0;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	position: absolute;
}

@media (max-width: 991px) {
	.inbox-wrapper .email-aside .aside-content .aside-header .navbar-toggle {
		display: block;
	}
}

.inbox-wrapper .email-aside .aside-content .aside-header .navbar-toggle .icon {
	font-size: 24px;
	color: #71738d;
}

.inbox-wrapper .email-aside .aside-content .aside-compose {
	text-align: center;
	padding: 14px 0;
}

.inbox-wrapper .email-aside .aside-content .aside-compose .btn,
.inbox-wrapper .email-aside .aside-content .aside-compose .fc .fc-button,
.fc .inbox-wrapper .email-aside .aside-content .aside-compose .fc-button,
.inbox-wrapper .email-aside .aside-content .aside-compose .swal2-modal .swal2-actions button,
.swal2-modal .swal2-actions .inbox-wrapper .email-aside .aside-content .aside-compose button,
.inbox-wrapper .email-aside .aside-content .aside-compose .wizard>.actions a,
.wizard>.actions .inbox-wrapper .email-aside .aside-content .aside-compose a {
	padding: 11px;
}

.inbox-wrapper .email-aside .aside-content .aside-nav {
	visibility: visible;
	padding: 0 0;
}

.inbox-wrapper .email-aside .aside-content .aside-nav.collapse {
	display: block;
}

@media (max-width: 991px) {
	.inbox-wrapper .email-aside .aside-content .aside-nav.collapse {
		display: none;
	}
}

@media (max-width: 991px) {
	.inbox-wrapper .email-aside .aside-content .aside-nav.show {
		display: block;
	}
}

.inbox-wrapper .email-aside .aside-content .aside-nav .title {
	display: block;
	color: #3d405c;
	font-size: 12px;
	font-weight: 700;
	text-transform: uppercase;
	margin: 20px 0 0;
	padding: 8px 14px 4px;
}

.inbox-wrapper .email-aside .aside-content .aside-nav .nav li {
	width: 100%;
}

.inbox-wrapper .email-aside .aside-content .aside-nav .nav li a {
	display: -webkit-flex;
	display: flex;
	-webkit-align-items: center;
	align-items: center;
	position: relative;
	color: #71748d;
	padding: 7px 14px;
}

.inbox-wrapper .email-aside .aside-content .aside-nav .nav li a:hover {
	text-decoration: none;
	background-color: rgba(114, 124, 245, 0.1);
	color: #727cf5;
}

.inbox-wrapper .email-aside .aside-content .aside-nav .nav li a .icon svg {
	width: 18px;
	margin-right: 10px;
}

.inbox-wrapper .email-aside .aside-content .aside-nav .nav li a .badge {
	margin-left: auto;
}

.inbox-wrapper .email-aside .aside-content .aside-nav .nav li a svg {
	width: 18px;
	margin-right: 10px;
}

.inbox-wrapper .email-aside .aside-content .aside-nav .nav li.active a {
	color: #ff3366;
	background: rgba(255, 51, 102, 0.1);
}

.inbox-wrapper .email-aside .aside-content .aside-nav .nav li.active a .icon {
	color: #ff3366;
}

.inbox-wrapper .email-content .email-inbox-header {
	background-color: transparent;
	padding: 18px 18px;
}

.inbox-wrapper .email-content .email-inbox-header .email-title {
	display: -webkit-flex;
	display: flex;
	-webkit-align-items: center;
	align-items: center;
	font-size: 1rem;
}

.inbox-wrapper .email-content .email-inbox-header .email-title svg {
	width: 20px;
	margin-right: 10px;
	color: #686868;
}

.inbox-wrapper .email-content .email-inbox-header .email-title .new-messages {
	font-size: .875rem;
	color: #686868;
	margin-left: 3px;
}

.inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .btn,
.inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .fc .fc-button,
.fc .inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .fc-button,
.inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .swal2-modal .swal2-actions button,
.swal2-modal .swal2-actions .inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn button,
.inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .wizard>.actions a,
.wizard>.actions .inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn a {
	border-radius: 0;
	padding: 4.5px 10px;
}

.inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .btn svg,
.inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .fc .fc-button svg,
.fc .inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .fc-button svg,
.inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .swal2-modal .swal2-actions button svg,
.swal2-modal .swal2-actions .inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn button svg,
.inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn .wizard>.actions a svg,
.wizard>.actions .inbox-wrapper .email-content .email-inbox-header .input-search .input-group-btn a svg {
	width: 18px;
}

.inbox-wrapper .email-content .email-filters {
	padding: 20px;
	border-bottom: 1px solid #e8ebf1;
	background-color: transparent;
	width: 100%;
	border-top: 1px solid #e8ebf1;
}

.inbox-wrapper .email-content .email-filters>div {
	display: -webkit-flex;
	display: flex;
	-webkit-align-items: center;
	align-items: center;
}

.inbox-wrapper .email-content .email-filters .email-filters-left .btn-group,
.inbox-wrapper .email-content .email-filters .email-filters-left .fc .fc-toolbar.fc-header-toolbar .fc-left .fc-button-group,
.fc .fc-toolbar.fc-header-toolbar .fc-left .inbox-wrapper .email-content .email-filters .email-filters-left .fc-button-group,
.inbox-wrapper .email-content .email-filters .email-filters-left .fc .fc-toolbar.fc-header-toolbar .fc-right .fc-button-group,
.fc .fc-toolbar.fc-header-toolbar .fc-right .inbox-wrapper .email-content .email-filters .email-filters-left .fc-button-group {
	margin-right: 5px;
}

.inbox-wrapper .email-content .email-filters .email-filters-left input {
	margin-right: 8px;
}

.inbox-wrapper .email-content .email-filters .email-filters-right {
	text-align: right;
}

@media (max-width: 767px) {
	.inbox-wrapper .email-content .email-filters .email-filters-right {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.single-option-toggle-small .choise_2 {
		white-space: break-spaces !important;
		padding-left: 60px;
	}
}

.inbox-wrapper .email-content .email-filters .email-filters-right .email-pagination-indicator {
	display: inline-block;
	vertical-align: middle;
	margin-right: 13px;
}

.inbox-wrapper .email-content .email-filters .email-filters-right .email-pagination-nav .btn svg,
.inbox-wrapper .email-content .email-filters .email-filters-right .email-pagination-nav .fc .fc-button svg,
.fc .inbox-wrapper .email-content .email-filters .email-filters-right .email-pagination-nav .fc-button svg,
.inbox-wrapper .email-content .email-filters .email-filters-right .email-pagination-nav .swal2-modal .swal2-actions button svg,
.swal2-modal .swal2-actions .inbox-wrapper .email-content .email-filters .email-filters-right .email-pagination-nav button svg,
.inbox-wrapper .email-content .email-filters .email-filters-right .email-pagination-nav .wizard>.actions a svg,
.wizard>.actions .inbox-wrapper .email-content .email-filters .email-filters-right .email-pagination-nav a svg {
	width: 18px;
}

.inbox-wrapper .email-content .email-filters .be-select-all.custom-checkbox {
	display: inline-block;
	vertical-align: middle;
	padding: 0;
	margin: 0 30px 0 0;
}

.inbox-wrapper .email-content .email-list .email-list-item {
	display: -webkit-flex;
	display: flex;
	-webkit-align-items: center;
	align-items: center;
	border-bottom: 1px solid #e8ebf1;
	padding: 10px 20px;
	width: 100%;
	cursor: pointer;
	position: relative;
	font-size: 14px;
	cursor: pointer;
	transition: background .2s ease-in-out;
}

.inbox-wrapper .email-content .email-list .email-list-item:hover {
	background: rgba(114, 124, 245, 0.08);
}

.inbox-wrapper .email-content .email-list .email-list-item:last-child {
	margin-bottom: 5px;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-actions {
	width: 40px;
	vertical-align: top;
	display: table-cell;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-actions .form-check {
	margin-bottom: 0;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-actions .form-check i::before {
	width: 15px;
	height: 15px;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-actions .form-check i::after {
	font-size: .8rem;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-actions .favorite {
	display: block;
	padding-left: 1px;
	line-height: 15px;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-actions .favorite span svg {
	width: 14px;
	color: #686868;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-actions .favorite:hover span {
	color: #8d8d8d;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-actions .favorite.active span svg {
	color: #fbbc06;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-detail {
	display: -webkit-flex;
	display: flex;
	-webkit-justify-content: space-between;
	justify-content: space-between;
	-webkit-flex-grow: 1;
	flex-grow: 1;
	-webkit-flex-wrap: wrap;
	flex-wrap: wrap;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-detail .from {
	display: block;
	font-weight: 400;
	margin: 0 0 1px 0;
	color: #000;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-detail .msg {
	margin: 0;
	color: #71738d;
	font-size: .8rem;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-detail .date {
	color: #000;
}

.inbox-wrapper .email-content .email-list .email-list-item .email-list-detail .date .icon svg {
	width: 14px;
	margin-right: 7px;
	color: #3d405c;
}

.inbox-wrapper .email-content .email-list .email-list-item.email-list-item--unread {
	background-color: rgba(114, 124, 245, 0.09);
}

.inbox-wrapper .email-content .email-list .email-list-item.email-list-item--unread .from {
	color: #000;
	font-weight: 800;
}

.inbox-wrapper .email-content .email-list .email-list-item.email-list-item--unread .msg {
	font-weight: 700;
	color: #686868;
}

.rtl .inbox-wrapper .email-aside .aside-content .aside-header .navbar-toggle .icon {
	position: absolute;
	top: 0;
	left: 0;
}

.rtl .inbox-wrapper .email-aside .aside-content .aside-nav .nav {
	padding-right: 0;
}

.rtl .inbox-wrapper .email-aside .aside-content .aside-nav .nav li a .icon svg {
	margin-right: 0;
	margin-left: 10px;
}

.rtl .inbox-wrapper .email-aside .aside-content .aside-nav .nav li a .badge {
	margin-left: 0;
	margin-right: auto;
}

.rtl .inbox-wrapper .email-aside .aside-content .aside-nav .nav li a svg {
	margin-right: 0;
	margin-left: 10px;
}

.rtl .inbox-wrapper .email-content .email-inbox-header .email-title svg {
	margin-right: 0;
	margin-left: 10px;
}

.rtl .inbox-wrapper .email-content .email-inbox-header .email-title .new-messages {
	margin-left: 0;
	margin-right: 3px;
}

.rtl .inbox-wrapper .email-content .email-filters .email-pagination-indicator {
	margin-right: 0;
	margin-left: 13px;
}

.rtl .inbox-wrapper .email-content .email-list .email-list-item .email-list-detail .date .icon svg {
	margin-right: 0;
	margin-left: 7px;
}

.email-head {
	background-color: transparent;
}

.email-head-subject {
	padding: 25px 25px;
	border-bottom: 1px solid #e8ebf1;
}

@media (max-width: 767px) {
	.email-head-subject {
		padding: 25px 10px;
	}
}

.email-head-subject .title {
	display: block;
	font-size: .99rem;
}

.email-head-subject .title a.active .icon {
	color: #fbbc06;
}

.email-head-subject .title a .icon {
	color: silver;
	margin-right: 6px;
}

.email-head-subject .title a .icon svg {
	width: 18px;
}

.email-head-subject .icons {
	font-size: 14px;
	float: right;
}

.email-head-subject .icons .icon {
	color: #000;
	margin-left: 12px;
}

.email-head-subject .icons .icon svg {
	width: 18px;
}

.email-head-sender {
	padding: 13px 25px;
}

@media (max-width: 767px) {
	.email-head-sender {
		padding: 25px 10px;
	}
}

.email-head-sender .avatar {
	float: left;
	margin-right: 10px;
}

.email-head-sender .date {
	float: right;
	font-size: 12px;
}

.email-head-sender .avatar {
	float: left;
	margin-right: 10px;
}

.email-head-sender .avatar img {
	width: 36px;
}

.email-head-sender .sender>a {
	color: #000;
}

.email-head-sender .sender span {
	margin-right: 5px;
	margin-left: 5px;
}

.email-head-sender .sender .actions {
	display: inline-block;
	position: relative;
}

.email-head-sender .sender .actions .icon {
	color: #686868;
	margin-left: 7px;
}

.email-head-sender .sender .actions .icon svg {
	width: 18px;
}

.email-body {
	background-color: transparent;
	border-top: 1px solid #e8ebf1;
	padding: 30px 28px;
}

@media (max-width: 767px) {
	.email-body {
		padding: 30px 10px;
	}
}

.email-attachments {
	background-color: transparent;
	padding: 25px 28px 5px;
	border-top: 1px solid #e8ebf1;
}

@media (max-width: 767px) {
	.email-attachments {
		padding: 25px 10px 0;
	}
}

.email-attachments .title {
	display: block;
	font-weight: 500;
}

.email-attachments .title span {
	font-weight: 400;
}

.email-attachments ul {
	list-style: none;
	margin: 15px 0 0;
	padding: 0;
}

.email-attachments ul>li {
	margin-bottom: 5px;
}

.email-attachments ul>li:last-child {
	margin-bottom: 0;
}

.email-attachments ul>li a {
	color: #000;
}

.email-attachments ul>li a svg {
	width: 18px;
	color: #686868;
}

.email-attachments ul>li .icon {
	color: #737373;
	margin-right: 2px;
}

.email-attachments ul>li span {
	font-weight: 400;
}

.rtl .email-head-subject .title a .icon {
	margin-right: 0;
	margin-left: 6px;
}

.rtl .email-head-subject .icons .icon {
	margin-left: 0;
	margin-right: 12px;
}

.rtl .email-head-sender .avatar {
	margin-right: 0;
	margin-left: 10px;
}

.rtl .email-head-sender .sender .actions .icon {
	margin-left: 0;
	margin-right: 7px;
}

.email-head-title {
	padding: 15px;
	border-bottom: 1px solid #e8ebf1;
	font-weight: 400;
	color: #3d405c;
	font-size: .99rem;
}

.email-head-title .icon {
	color: #696969;
	margin-right: 12px;
	vertical-align: middle;
	line-height: 31px;
	position: relative;
	top: -1px;
	float: left;
	font-size: 1.538rem;
}

.email-compose-fields {
	background-color: transparent;
	padding: 20px 15px;
}

.email-compose-fields .select2-container--default .select2-selection--multiple .select2-selection__rendered {
	margin: -2px -14px;
}

.email-compose-fields .select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-selection__choice {
	border-radius: 0;
	background: #727cf5;
	color: #ffffff;
	margin-top: 0px;
	padding: 4px 10px;
	font-size: 13px;
	border: 0;
}

.email-compose-fields .select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-selection__choice span {
	color: #ffffff;
}

.email-compose-fields .select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-search {
	line-height: 15px;
}

.form-group.row {
	margin-bottom: 0;
	padding: 12px 0;
}

.form-group.row label {
	white-space: nowrap;
}

.email-compose-fields label {
	padding-top: 6px;
}

.email.editor {
	background-color: transparent;
}

.email.editor .editor-statusbar {
	display: none;
}

.email.action-send {
	padding: 8px 0px 0;
}

.btn-space {
	margin-right: 5px;
	margin-bottom: 5px;
}

.breadcrumb {
	margin: 0;
	background-color: transparent;
}

.rtl .email-compose-fields .select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-selection__choice {
	float: right;
}

.rtl .btn-space {
	margin-right: 0;
	margin-left: 5px;
}

.card {
	box-shadow: 0 0 10px 0 rgba(183, 192, 206, 0.2);
	-webkit-box-shadow: 0 0 10px 0 rgba(183, 192, 206, 0.2);
	-moz-box-shadow: 0 0 10px 0 rgba(183, 192, 206, 0.2);
	-ms-box-shadow: 0 0 10px 0 rgba(183, 192, 206, 0.2);
}

.card {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: border-box;
	border: 1px solid #f2f4f9;
	border-radius: 0.25rem;
}

.badge {
	padding: 6px 5px 3px;
}

.text-white {
	color: #ffffff !important;
}

.font-weight-bold {
	font-weight: 700 !important;
}

.float-right {
	float: right !important;
}

.badge-danger-muted {
	color: #212529;
	background-color: #f77eb9;
}

.mx-datepicker {
	width: 100% !important;
}

// .mx-datepicker input{
// 	border: 0;
//     box-shadow: none !important;
// 	background-image: linear-gradient(to top, #9c27b0 2px, rgba(156, 39, 176, 0) 2px), linear-gradient(to top, #d2d2d2 1px, rgba(210, 210, 210, 0) 1px);
//     border-radius: 0;
// 	background-size: 0 100%, 100% 100%;
// }
// .mx-datepicker input:focus{
// 	background-size: 100% 100%, 100% 100%;
//     transition-duration: 0.1s;
// }</style>